import type { Catalogue } from './fr.ts';

export const de: Catalogue = {
  'app.name': 'Tablo',
  'app.tagline': 'Elektroschaltpläne für Installateure',
  'menu.file': 'Datei',
  'menu.new': 'Neu',
  'menu.open': 'Öffnen…',
  'menu.save': 'Speichern',
  'menu.saveAs': 'Speichern unter…',
  'menu.export': 'Exportieren',
  'menu.exportPdf': 'PDF (alle Blätter)',
  'menu.exportSvg': 'SVG (aktuelles Blatt)',
  'menu.exportPng': 'PNG (aktuelles Blatt)',
  'menu.print': 'Drucken…',
  'menu.projectInfo': 'Projektinformationen',
  'menu.demo': 'Beispiel',
  'menu.benchmark': 'Leistungstest',
  'menu.undo': 'Rückgängig',
  'menu.redo': 'Wiederholen',
  'menu.fit': 'Alles anzeigen',
  'menu.language': 'Sprache',
  'menu.copy': 'Kopieren',
  'menu.cut': 'Ausschneiden',
  'menu.paste': 'Einfügen',
  'menu.duplicate': 'Duplizieren',
  'menu.selectAll': 'Alles auswählen',
  'tool.select': 'Auswahl',
  'tool.wire': 'Leitung',
  'tool.text': 'Text',
  'tool.rotate': 'Drehen',
  'tool.mirror': 'Spiegeln',
  'tool.delete': 'Löschen',
  'sheet.add': 'Neues Blatt',
  'sheet.rename': 'Umbenennen',
  'sheet.delete': 'Blatt löschen',
  'sheet.confirmDelete': 'Das Blatt „{name}“ und sein gesamter Inhalt werden gelöscht.',
  'sheet.lastOne': 'Ein Projekt muss mindestens ein Blatt behalten.',
  'sheetKind.single-line': 'Einliniendiagramm',
  'sheetKind.multi-line': 'Mehrliniendiagramm',
  'sheetKind.control': 'Steuerstromlaufplan',
  'sheetKind.position-plan': 'Lageplan',
  'sheetKind.board': 'Verteileransicht',
  'status.elements': '{n} Elemente',
  'status.wires': '{n} Leitungen',
  'status.zoom': 'Zoom {pct} %',
  'status.platform.desktop': 'Desktop',
  'status.platform.mobile': 'Mobil',
  'status.platform.web': 'Web',
  'status.saved': 'Gespeichert',
  'status.unsaved': 'Ungespeicherte Änderungen',
  'status.autosaved': 'Sicherungskopie um {time}',
  'status.exported': 'Exportiert: {name}',
  'panel.selection': 'Auswahl',
  'panel.noSelection': 'Nichts ausgewählt',
  'panel.multi': '{n} Elemente ausgewählt',
  'panel.tag': 'Kennzeichen',
  'panel.tagDuplicate': 'Dieses Kennzeichen wird bereits verwendet',
  'panel.symbol': 'Symbol',
  'panel.position': 'Position (mm)',
  'panel.rotation': 'Drehung',
  'panel.mirrored': 'Gespiegelt',
  'panel.wire': 'Leitung',
  'panel.wireLabel': 'Beschriftung / Kabel',
  'panel.wireLabelHint': 'z. B. XVB 3G2.5',
  'panel.sheet': 'Blatt',
  'panel.sheetName': 'Name',
  'panel.sheetKind': 'Plantyp',
  'panel.paper': 'Papier',
  'panel.orientation': 'Ausrichtung',
  'panel.landscape': 'Querformat',
  'panel.portrait': 'Hochformat',
  'panel.symbols': 'Symbole',
  'panel.search': 'Symbole suchen…',
  'panel.noResults': 'Keine Symbole gefunden',
  'panel.allSheets': 'Alle Symbole',
  'cat.protection': 'Schutz',
  'cat.distribution': 'Verteilung',
  'cat.outlet': 'Steckdosen',
  'cat.appliance': 'Geräte',
  'cat.lighting': 'Beleuchtung',
  'cat.command': 'Schalter',
  'cat.control': 'Steuerung',
  'cat.motor': 'Motoren',
  'cat.signalling': 'Signalisierung',
  'cat.connection': 'Anschluss',
  'cat.earth': 'Erdung',
  'cat.annotation': 'Beschriftung',
  'meta.title': 'Projektname',
  'meta.ownerName': 'Eigentümer',
  'meta.ownerAddress': 'Adresse des Eigentümers',
  'meta.installationAddress': 'Adresse der Anlage (falls abweichend)',
  'meta.author': 'Gezeichnet von',
  'meta.company': 'Firma',
  'meta.date': 'Datum',
  'meta.earthingSystem': 'Netzsystem',
  'meta.supplyVoltage': 'Versorgungsspannung',
  'meta.locale': 'Sprache der Pläne',
  'meta.standard': 'Norm',
  'meta.standardHint': 'Regelwerk, nach dem das Projekt geprüft wird.',
  'std.rgie': 'AREI',
  'std.nfc15100': 'NF C 15-100',
  'std.nen1010': 'NEN 1010',
  'std.label.rgie': 'AREI (Belgien)',
  'std.label.nfc15100': 'NF C 15-100 (Frankreich)',
  'std.label.nen1010': 'NEN 1010 (Niederlande)',
  'meta.hint': 'Diese Angaben erscheinen im Schriftfeld jedes Blattes.',
  'tb.project': 'Projekt',
  'tb.sheet': 'Blatt',
  'tb.sheetNo': 'Nr.',
  'tb.owner': 'Eigentümer',
  'tb.date': 'Datum',
  'tb.paper': 'Papier',
  'tb.installation': 'Adresse der Anlage',
  'tb.supply': 'Spannung',
  'tb.earthing': 'Netzsystem',
  'tb.author': 'Gezeichnet von / Firma',
  'tb.diagram': 'Plantyp',
  'dialog.ok': 'OK',
  'dialog.cancel': 'Abbrechen',
  'dialog.close': 'Schließen',
  'dialog.delete': 'Löschen',
  'dialog.discard': 'Änderungen verwerfen',
  'confirm.discard': 'Ungespeicherte Änderungen gehen verloren.',
  'confirm.discardTitle': 'Änderungen verwerfen?',
  'recovery.title': 'Ungespeicherte Arbeit wiederherstellen?',
  'recovery.body': '„{name}“ wurde am {date} geändert und nicht gespeichert.',
  'recovery.restore': 'Wiederherstellen',
  'recovery.dismiss': 'Ignorieren',
  'recovery.delete': 'Löschen',
  'recovery.fromAccount': '(Kopie aus Ihrem Konto)',
  'recovery.pick': 'Wiederherzustellende Kopie',
  'bench.title': 'Leistungstest',
  'bench.running': 'Messung läuft… ({n} Elemente)',
  'bench.result': '{n} Elemente · {fps} fps · mittl. Frame {avg} ms · p95 {p95} ms',
  'error.open': 'Datei konnte nicht geöffnet werden: {msg}',
  'error.save': 'Speichern nicht möglich: {msg}',
  'error.export': 'Export nicht möglich: {msg}',
  'hint.canvas':
    'Ziehen: auswählen · Mausrad: zoomen · Mittelklick, Leertaste + Ziehen oder zwei Finger: verschieben',
  'hint.place': 'Klick: platzieren · R: drehen · Esc: fertig',
  'hint.wire':
    'Klemme anklicken zum Starten · Klick: Ecke · Doppelklick: beenden · Rücktaste: Ecke zurück · Esc: abbrechen',
  'tx.move': 'Verschieben',
  'tx.add': '{name} hinzufügen',
  'tx.delete': 'Löschen',
  'tx.rotate': 'Drehen',
  'tx.mirror': 'Spiegeln',
  'tx.wire': 'Leitung zeichnen',
  'tx.paste': 'Einfügen',
  'tx.edit': 'Bearbeiten',
  'tx.sheetAdd': 'Blatt hinzufügen',
  'tx.sheetDelete': 'Blatt löschen',
  'tx.meta': 'Projektinformationen',
  'tool.room': 'Raum',
  'tool.calibrate': 'Maßstab festlegen',
  'panel.circuits': 'Stromkreise',
  'panel.checks': 'Prüfung {std}',
  'panel.hide': 'Bereich ausblenden',
  'panel.background': 'Planhintergrund',
  'circ.code': 'Stromkreis',
  'circ.label': 'Bezeichnung',
  'circ.protection': 'Schutz',
  'circ.rcd': 'FI',
  'circ.cableType': 'Kabel',
  'circ.section': 'mm²',
  'circ.cores': 'Adern',
  'circ.length': 'Länge (m)',
  'circ.points': 'Punkte',
  'circ.legacy': 'Altanlage',
  'circ.add': 'Stromkreis hinzufügen',
  'circ.renumber': 'Stromkreise nummerieren',
  'circ.empty':
    'Keine Stromkreise: Fügen Sie einen LS in einem Einliniendiagramm hinzu, importieren Sie ein Foto des Verteilers oder fragen Sie den KI-Assistenten.',
  'circ.mainBus': 'Hauptsammelschiene',
  'circ.kindSockets': 'Steckdosen',
  'circ.kindLights': 'Beleuchtung',
  'circ.kindAppliance': 'Gerät',
  'circ.newLabel': 'Neuer Stromkreis',
  'circ.show': 'Im Plan anzeigen',
  'circ.noSingleLine': 'Fügen Sie zuerst ein Blatt „Einliniendiagramm“ hinzu.',
  'checks.ok': 'Nach den aktuellen Regeln wurde kein Problem gefunden.',
  'checks.summary': '{e} Fehler, {w} Warnung(en), {i} Hinweis(e)',
  'checks.unverified': 'Regel zu bestätigen',
  'checks.why': 'Warum',
  'checks.fix': 'Beheben',
  'checks.askAssistant': 'Mit dem Assistenten beheben',
  'checks.goProjectInfo': 'Projektinformationen ausfüllen',
  'checks.goMeasurements': 'Messergebnisse eingeben',
  'checks.goCircuits': 'Stromkreistabelle öffnen',
  'checks.goProperties': 'Eigenschaften bearbeiten',
  'checks.goSheet': 'Blatteinstellungen',
  'checks.goShow': 'Im Plan anzeigen',
  'checks.goNewPlan': 'Leeren Lageplan anlegen',
  'checks.goAddEarth': 'Erder hinzufügen',
  'checks.goQuick': 'Beheben',
  'checks.quickMove30': 'Unter {tag} (30 mA) verschieben',
  'checks.quickTypeA': '{tag} auf Typ A ändern',
  'checks.quickMain300': '{tag} auf 300 mA setzen',
  'checks.quickRating': 'Auf {tag} senken',
  'checks.quickSection': 'Kabel {tag} (neu verdrahten)',
  'circ.estimated': 'Aus dem Plan geschätzt: vor Ort prüfen',
  'checks.goRenumber': 'Stromkreise nummerieren',
  'checks.goNumberTerminals': 'Klemmen nummerieren',
  'checks.goA3': 'Blatt auf A3 umstellen',
  'checks.goEarthSockets': 'Durch Schutzkontaktsteckdosen ersetzen',
  'checks.goRename': '{from} in {tag} umbenennen',
  'checks.goAttach': 'Mit Stromkreis verbinden…',
  'checks.goDrawRoom': 'Raum darum zeichnen',
  'checks.goDelete': 'Löschen',
  'checks.goSpare': 'Als Reserve markieren',
  'checks.goEstimate': 'Aus dem Plan schätzen',
  'checks.goPhoto': 'Von einem Foto ablesen',
  'checks.estimated': 'Längen aus dem Plan geschätzt für {codes}: vor Ort prüfen.',
  'checks.estimateNone':
    'Kein Stromkreis konnte im Plan gemessen werden (Verteiler und Punkte auf einem importierten Grundriss erforderlich).',
  'checks.photoRead': 'Auf dem Foto erkannt: {what}. Bitte prüfen.',
  'checks.photoNone': 'Auf dem Foto ist nichts lesbar.',
  'circ.spare': 'Reserve',
  'measure.again': 'Erneut messen',
  'measure.previous': 'Vorher: {what} ({date})',
  'checks.attached': '{tag} mit Stromkreis {code} verbunden.',
  'checks.disclaimer':
    'Hilft bei der Vorbereitung der Kontrolle — ersetzt nicht die Prüfung durch eine zugelassene Kontrollstelle.',
  'status.checks': '{std}: {e} Fehler · {w} Warn.',
  'plan.import': 'Plan importieren (Bild, PDF, DXF oder Raumscan)…',
  'plan.replace': 'Plan ersetzen…',
  'plan.remove': 'Hintergrund entfernen',
  'plan.opacity': 'Deckkraft',
  'plan.scale': 'Maßstab 1:',
  'plan.calibrate': 'Maßstab festlegen…',
  'plan.calibrateHint':
    'Klicken Sie auf zwei Punkte, deren tatsächlichen Abstand Sie kennen (z. B. eine Wand).',
  'plan.distance': 'Tatsächlicher Abstand zwischen den beiden Punkten (m)',
  'plan.measured': 'Auf dem Blatt gemessen: {mm} mm',
  'plan.toPlace': 'Im Plan zu platzieren',
  'plan.allPlaced': 'Alle Punkte des Schemas sind platziert.',
  'plan.importing': 'Plan wird importiert…',
  'plan.noBackground': 'Kein Hintergrundplan.',
  'ai.menu': 'KI',
  'ai.board': 'Foto des Verteilers importieren…',
  'ai.demoBanner':
    'Demomodus: Die KI ist noch nicht verbunden. Das Ergebnis unten ist ein Beispiel; das Foto wird nicht analysiert.',
  'ai.demoText': 'Demomodus: vereinfachte lokale Auswertung (ohne KI).',
  'aiGate.title': 'KI-Funktionen (Beta) mit einem kostenlosen Tablo-Konto',
  'aiGate.intro':
    'Die KI-Funktionen sind während der Beta kostenlos; Sie müssen nur angemeldet sein. Das erledigen sie für Sie:',
  'aiGate.tab.assist': 'Assistent',
  'aiGate.tab.board': 'Verteilerfoto',
  'aiGate.tab.sketch': 'Skizze',
  'aiGate.tab.report': 'Kontrollbericht',
  'aiGate.cap.assist':
    'Beschreiben Sie eine Änderung in eigenen Worten: Der Assistent bereitet sie vor und Sie übernehmen sie mit einem Klick.',
  'aiGate.cap.board':
    'Fotografieren Sie einen bestehenden Verteiler: Seine FI und Stromkreise werden für Sie erkannt.',
  'aiGate.cap.sketch': 'Ein handgezeichnetes Einliniendiagramm wird zu einem sauberen, bearbeitbaren Plan.',
  'aiGate.cap.report':
    'Importieren Sie den Bericht einer zugelassenen Kontrollstelle: Die Bemerkungen werden übernommen und können nachverfolgt werden.',
  'aiGate.signIn': 'Anmelden oder Konto erstellen',
  'aiGate.later': 'Nicht jetzt',
  'ai.choosePhoto': 'Foto auswählen…',
  'ai.analyse': 'Analysieren',
  'ai.analysing': 'Wird analysiert…',
  'ai.preview': 'Vorschau',
  'ai.previewHint':
    'Fahren Sie über den Vorschlag, um ihn im Plan zu sehen; klicken Sie, um die Vorschau beizubehalten.',
  'ai.previewBanner':
    'Vorschau des Vorschlags, noch nicht übernommen: {added} hinzugefügt, {changed} geändert, {removed} entfernt',
  'ai.rechecking': 'Eine Hutschiene wird aus der Nähe erneut gelesen…',
  'ai.recheckNote': 'Schiene {rail} aus der Nähe erneut gelesen: {labels} korrigiert.',
  'ai.review': 'Prüfen Sie jede Zeile vor dem Import. Unsichere Werte sind hervorgehoben.',
  'ai.row': 'Schiene',
  'ai.pos': 'Pos.',
  'ai.type': 'Gerät',
  'ai.rating': 'A',
  'ai.curve': 'Kennlinie',
  'ai.sens': 'mA',
  'ai.rcdType': 'Typ',
  'ai.label': 'Bezeichnung',
  'ai.confidence': 'Sicherheit',
  'ai.import': 'Einliniendiagramm erstellen',
  'ai.notes': 'Hinweise',
  'ai.target': 'Hinzufügen unter',
  'ai.error': 'KI-Fehler: {msg}',
  'ai.unavailable':
    'Die KI-Funktionen (Beta) sind vorübergehend nicht verfügbar. Versuchen Sie es später erneut: Der Rest von Tablo funktioniert wie gewohnt.',
  'ai.removeRow': 'Zeile entfernen',
  'ai.addRow': 'Zeile hinzufügen',
  'ai.dt.main-switch': 'Hauptschalter',
  'ai.dt.RCD': 'FI',
  'ai.dt.MCB': 'LS',
  'ai.dt.RCBO': 'FI/LS',
  'ai.dt.fuse': 'Sicherung',
  'ai.dt.contactor': 'Schütz',
  'ai.dt.timer': 'Zeitrelais',
  'ai.dt.meter': 'Zähler',
  'ai.dt.other': 'Sonstiges',
  'ai.toFill': 'Punkte und Kabel noch auszufüllen: Ein Foto zeigt sie nicht.',
  'menu.reports': 'Berichte',
  'menu.circuitsCsv': 'Stromkreisliste (CSV)',
  'menu.bomCsv': 'Materialliste (CSV)',
  'menu.labelsPdf': 'Verteilerbeschriftung (PDF)',
  'menu.exportPdfFull': 'PDF + Stromkreisliste',
  'tx.calibrate': 'Maßstab festlegen',
  'tx.background': 'Planhintergrund',
  'tx.circuit': 'Stromkreis bearbeiten',
  'tx.addCircuit': 'Stromkreis hinzufügen',
  'tx.renumber': 'Stromkreise nummerieren',
  'tx.aiImport': 'KI-Import des Verteilers',
  'room.default': 'Raum',
  'hint.room': 'Ziehen, um einen Raum zu zeichnen · Esc: fertig',
  'hint.calibrate': 'Ersten Punkt anklicken, dann den zweiten · Esc: abbrechen',
  'menu.diagram': 'Schema',
  'menu.newFromTemplate': 'Neu aus Vorlage…',
  'menu.terminalPlanCsv': 'Klemmenplan (CSV)',
  'cmd.multiLine': 'Mehrliniendiagramm erzeugen / aktualisieren',
  'cmd.numberWires': 'Leitungen auf diesem Blatt nummerieren',
  'cmd.numberTerminals': 'Klemmen nummerieren',
  'cmd.insert': 'Einfügen',
  'cmd.nothing': 'Nichts zu ändern',
  'cmd.multiLineDone': 'Mehrliniendiagramm „{name}“ ist aktuell',
  'tpl.title': 'Neues Projekt aus einer Vorlage',
  'tpl.create': 'Erstellen',
  'ml.generated': 'Aus „{name}“ erzeugtes Blatt: Manuelle Änderungen gehen beim Aktualisieren verloren.',
  'ml.stale': 'Das Einliniendiagramm „{name}“ wurde geändert: Dieses erzeugte Blatt ist veraltet.',
  'ml.update': 'Aktualisieren',
  'tx.multiLine': 'Mehrliniendiagramm',
  'tx.numberWires': 'Leitungen nummerieren',
  'tx.numberTerminals': 'Klemmen nummerieren',
  'tx.template': 'Einfügen: {name}',
  'tx.assistant': 'KI-Assistent',
  'tx.sketch': 'Skizzenimport',
  'ai.assistant': 'Assistent',
  'ai.sketch': 'Skizze → Schema…',
  'ai.send': 'Senden',
  'ai.askHint': 'Z. B. „Ladestation für E-Auto hinzufügen, dann das Mehrliniendiagramm erzeugen“',
  'ai.thinking': 'Denkt nach…',
  'ai.dictate': 'Diktieren',
  'ai.stopDictation': 'Diktat beenden ({s} s)',
  'ai.transcribing': 'Wird transkribiert…',
  'ai.micDenied': 'Mikrofonzugriff verweigert: Erlauben Sie ihn in den Browser- oder Geräteeinstellungen.',
  'ai.micMissing': 'Kein Mikrofon gefunden.',
  'ai.nothingHeard': 'Nichts gehört: Sprechen Sie näher am Mikrofon.',
  'ai.apply': 'Übernehmen',
  'ai.applied': 'Übernommen (rückgängig mit {mod}Z)',
  'ai.fbUp': 'Hilfreiche Antwort',
  'ai.fbDown': 'Falsche oder wenig hilfreiche Antwort',
  'ai.fbWhat': 'Was lief schief? (optional)',
  'ai.fbShare':
    'Diese Unterhaltung und das Projekt teilen (ohne Namen, Adressen oder Fotos), damit daraus ein Testfall wird',
  'ai.fbTrain': 'Auch zum Training des eigenen KI-Modells von Tablo verwenden',
  'ai.fbShareHint':
    'Höchstens 12 Monate aufbewahrt, nur von Tablo. Ein damit bereits trainiertes Modell wird beim Löschen nicht neu trainiert. Siehe Datenschutzerklärung.',
  'ai.fbShareGood': 'Diese Antwort als gutes Beispiel teilen?',
  'ai.fbSend': 'Senden',
  'ai.fbCancel': 'Abbrechen',
  'ai.fbThanks': 'Danke für Ihr Feedback.',
  'ai.fbError': 'Feedback nicht gesendet: {msg}',
  'ai.skipped': 'Nicht übernommen: {msg}',
  'ai.proposal': 'Vorgeschlagene Änderungen',
  'ai.chooseSketch': 'Bild auswählen…',
  'ai.sketchHint': 'Foto oder Scan eines handgezeichneten Einliniendiagramms.',
  'ai.sketchResult': '{n} Stromkreis(e) erkannt, in {g} Gruppe(n).',
  'ai.mainRcd': 'Haupt-FI',
  'circ.method': 'Verlegeart',
  'circ.method.A1': 'A1 · Rohr in wärmegedämmter Wand',
  'circ.method.B1': 'B1 · im Rohr (in oder auf der Wand)',
  'circ.method.C': 'C · Kabel auf der Wand befestigt',
  'circ.ib': 'Ib (A)',
  'circ.iz': 'Iz (A)',
  'circ.drop': 'ΔU',
  'circ.lmax': 'Max. L',
  'circ.ibLoads': 'Aus der Leistung der Punkte berechnet',
  'circ.ibRating': 'Leistung unbekannt: mit dem Nennstrom der Schutzeinrichtung geprüft',
  'circ.dropLimit': 'Übliche Grenze: {pct} %',
  'circ.lmaxHint': 'Maximale gegen Kurzschluss geschützte Länge (konventionelles Verfahren)',
  'info.icc': 'Unbeeinflusster Kurzschlussstrom Icc am Anfang (kA)',
  'info.iccHint': 'Vom Netzbetreiber angegeben; dient zur Prüfung des Schaltvermögens.',
  'menu.exportDxf': 'DXF (aktuelles Blatt, für AutoCAD/QCAD…)',
  'tb.paperRev': 'Papier · Rev.',
  'rev.menu': 'Revisionen…',
  'rev.title': 'Revisionen',
  'rev.index': 'Rev.',
  'rev.date': 'Datum',
  'rev.author': 'Von',
  'rev.description': 'Änderung',
  'rev.new': 'Neue Revision',
  'rev.newHint': 'Friert das aktuelle Projekt als Revision {index} ein.',
  'rev.create': 'Revision {index} erstellen',
  'rev.none':
    'Noch keine Revisionen. Erstellen Sie Revision A, wenn Sie das Schema übergeben (an den Kunden, die Kontrollstelle…).',
  'rev.compare': 'Vergleichen',
  'rev.restore': 'Zu diesem Stand zurückkehren',
  'rev.restoreConfirm':
    'Projekt durch den Stand von Revision {index} ersetzen? (Kann rückgängig gemacht werden.)',
  'rev.diff': 'Verglichen mit Revision {index}: {added} hinzugefügt, {changed} geändert, {removed} entfernt',
  'rev.diffClose': 'Vergleich beenden',
  'tx.revision': 'Revision {index}',
  'tx.restoreRevision': 'Zurück zu Revision {index}',
  'rev.table': 'Revisionen',
  'menu.revisionsPdf': 'Revisionstabelle (im vollständigen PDF)',
  'cat.user': 'Meine Symbole',
  'sym.new': 'Neues Symbol…',
  'sym.edit': 'Symbol bearbeiten',
  'sym.newTitle': 'Neues Symbol',
  'sym.editTitle': 'Symbol bearbeiten',
  'sym.save': 'Symbol speichern',
  'sym.nameFr': 'Name (Französisch)',
  'sym.nameEn': 'Name (Englisch)',
  'sym.nameNl': 'Name (Niederländisch)',
  'sym.tagPrefix': 'Kennbuchstabe',
  'sym.width': 'Breite (mm)',
  'sym.height': 'Höhe (mm)',
  'sym.views': 'Verfügbar in',
  'sym.hint':
    'Raster 1,25 mm. Ziehen zum Zeichnen; „Anschlusspunkt“ fügt einen Punkt zum Anschließen von Leitungen hinzu oder entfernt ihn.',
  'sym.tool.line': 'Linie',
  'sym.tool.rect': 'Rechteck',
  'sym.tool.circle': 'Kreis',
  'sym.tool.dot': 'Scheibe',
  'sym.tool.text': 'Text',
  'sym.tool.port': 'Anschlusspunkt',
  'sym.tool.erase': 'Radieren',
  'sym.problems': 'Noch zu ergänzen: {list}',
  'sym.problem.name': 'Name',
  'sym.problem.empty': 'Zeichnung',
  'sym.problem.views': 'Plantypen',
  'sym.problem.port': 'doppelte Punkte',
  'sym.problem.port-outside': 'Punkt außerhalb des Rahmens',
  'tx.newSymbol': 'Neues Symbol: {name}',
  'tx.editSymbol': 'Symbol bearbeitet: {name}',
  'tx.importSymbols': 'Symbole importieren',
  'macro.title': 'Makros',
  'macro.none': 'Wählen Sie eine Gruppe von Elementen aus, dann „Schema → Auswahl als Makro speichern“.',
  'macro.save': 'Auswahl als Makro speichern…',
  'macro.name': 'Makroname',
  'macro.saved': 'Makro „{name}“ gespeichert',
  'macro.selectFirst': 'Wählen Sie zuerst die zu speichernden Elemente aus',
  'macro.insert': 'In der Mitte der Ansicht einfügen',
  'macro.delete': 'Makro löschen',
  'macro.deleteConfirm': 'Das Makro „{name}“ aus Ihrer Bibliothek löschen?',
  'lib.import': 'Importieren…',
  'lib.exportSymbols': 'Meine Symbole exportieren',
  'lib.exportMacros': 'Meine Makros exportieren',
  'lib.imported': '{n} Element(e) importiert',
  'lib.notLibrary': 'Diese Datei ist keine Tablo-Bibliothek',
  'lib.symbolsFile': 'Tablo-Symbole',
  'lib.macrosFile': 'Tablo-Makros',
  'cat.ref': 'Herstellerreferenz',
  'cat.none': '— keine —',
  'cat.noMatch': 'Keine passende Katalogreferenz',
  'cat.modules': '{n} Modul(e)',
  'cat.source': 'Quelle',
  'cat.mismatch': 'entspricht nicht mehr den Kenndaten',
  'cat.assign': 'Katalogreferenzen',
  'cat.assigned': '{n} {brand}-Referenz(en) zugewiesen; {missing} Gerät(e) ohne Treffer',
  'tx.assignBrand': '{brand}-Referenzen',
  'cmd.boardLayout': 'Verteileransicht erzeugen / aktualisieren',
  'tx.boardLayout': 'Verteileransicht',
  'legal.privacy': 'Datenschutzerklärung',
  'legal.support': 'Support',
  'legal.registerNote': 'Ihre Daten bleiben in Europa; Einzelheiten in der',
  'about.menu': 'Über Tablo…',
  'about.title': 'Über',
  'about.beta':
    'Kostenlose Beta. Funktionen können sich noch ändern; Ihre .elec-Dateien bleiben in späteren Versionen lesbar. Bitte melden Sie jedes Problem.',
  'about.data':
    'Ihre Projekte bleiben auf Ihrem Computer (oder in Ihrem Browser): Nichts wird an einen Server gesendet, außer den Fotos und Texten, die Sie der KI übermitteln.',
  'about.aiDemo': 'KI: Demomodus (keine Daten gesendet).',
  'about.aiRemote':
    'KI: Gesendete Fotos und Beschreibungen werden verarbeitet und dann gelöscht; sie werden nicht zum Training von Modellen verwendet.',
  'about.rules':
    'Die AREI-Prüfung ist eine Hilfe: Sie ersetzt weder das Lesen der AREI noch die Kontrolle durch eine zugelassene Kontrollstelle. Regeln „zu bestätigen“ sind gekennzeichnet.',
  'about.checkUpdates': 'Nach Updates suchen',
  'about.update.unavailable': 'Automatische Updates sind in dieser Version nicht verfügbar.',
  'about.update.up-to-date': 'Tablo ist auf dem neuesten Stand.',
  'about.update.installed': 'Update installiert.',
  'about.update.available': 'Update verfügbar.',
  'about.updateAvailable': 'Update verfügbar: {v}',
  'about.updateAvailableWord': 'verfügbar',
  'about.install': 'Installieren und neu starten',
  'welcome.title': 'Willkommen bei Tablo',
  'welcome.intro':
    'Tablo zeichnet die Pläne einer belgischen Elektroinstallation — Einliniendiagramm, Lageplan, Mehrliniendiagramm, Steuerstromlaufplan, Verteileransicht — und prüft sie laufend nach der AREI.',
  'welcome.s1.title': 'Der Verteiler',
  'welcome.s1.body':
    'Beginnen Sie mit einer Vorlage, fotografieren Sie den Verteiler (KI) oder fügen Sie Stromkreise im Bereich „Stromkreise“ hinzu.',
  'welcome.s2.title': 'Die Punkte',
  'welcome.s2.body':
    'Steckdosen, Beleuchtung und Geräte jedes Stromkreises, mit Kabellängen für die Berechnungen.',
  'welcome.s3.title': 'Der Lageplan',
  'welcome.s3.body':
    'Importieren Sie den Grundriss (PDF, Foto oder DXF), legen Sie den Maßstab fest und platzieren Sie die Punkte aus der Liste „Zu platzieren“.',
  'welcome.s4.title': 'Die Prüfung',
  'welcome.s4.body':
    '„AREI-Prüfung“ listet auf, was fehlt oder falsch ist; klicken Sie auf eine Zeile, um dorthin zu gelangen.',
  'welcome.s5.title': 'Die Übergabe',
  'welcome.s5.body':
    'Schema → Mehrliniendiagramm und Verteileransicht; Datei → Revisionen, dann das vollständige PDF für den Kunden und die Kontrollstelle exportieren.',
  'welcome.template': 'Mit einer Vorlage beginnen…',
  'welcome.demo': 'Beispiel öffnen',
  'welcome.empty': 'Leeres Projekt',
  'cloud.menu': 'Cloud',
  'cloud.open': 'Konto und Online-Projekte…',
  'cloud.leave': 'Online-Projekt verlassen (lokale Kopie behalten)',
  'cloud.title': 'Tablo online',
  'cloud.intro':
    'Mit einem Konto werden Ihre Projekte online gespeichert und zwischen Ihren Geräten synchronisiert; Sie können gemeinsam arbeiten und einen Nur-Lese-Link teilen.',
  'cloud.login': 'Anmelden',
  'cloud.register': 'Konto erstellen',
  'cloud.name': 'Name',
  'cloud.email': 'E-Mail',
  'cloud.password': 'Passwort',
  'cloud.passwordHint': 'Mindestens 8 Zeichen.',
  'cloud.forgot': 'Passwort vergessen?',
  'cloud.forgotTitle': 'Passwort vergessen',
  'cloud.forgotIntro':
    'Geben Sie die Adresse Ihres Kontos ein: Sie erhalten einen Link, um ein neues Passwort zu wählen.',
  'cloud.forgotSend': 'Link senden',
  'cloud.forgotSent':
    'Falls ein Konto für {email} existiert, ist eine E-Mail unterwegs. Der Link ist eine Stunde gültig; prüfen Sie auch Ihren Spam-Ordner.',
  'cloud.backToLogin': 'Zurück zur Anmeldung',
  'cloud.registerConfirmNote': 'Wir senden Ihnen per E-Mail einen Link zur Bestätigung Ihrer Adresse.',
  'cloud.pendingTitle': 'Bestätigen Sie Ihre E-Mail-Adresse',
  'cloud.pendingBody':
    'Wir haben einen Link an {email} gesendet. Öffnen Sie ihn, um Ihr Konto zu aktivieren; er ist 48 Stunden gültig.',
  'cloud.pendingSpam': 'Nichts angekommen? Prüfen Sie Ihren Spam-Ordner oder senden Sie den Link erneut.',
  'cloud.resend': 'Link erneut senden',
  'cloud.resent': 'Link erneut gesendet. Er ersetzt den vorherigen.',
  'cloud.pendingSignIn': 'Bereits bestätigt? Anmelden',
  'cloud.confirmTitle': 'Konto wird aktiviert',
  'cloud.confirming': 'Wird aktiviert…',
  'cloud.confirmExpired':
    'Dieser Link ist abgelaufen oder wurde bereits verwendet. Melden Sie sich an: Ist Ihre Adresse noch nicht bestätigt, können Sie einen neuen Link anfordern.',
  'cloud.confirmRetry': 'Erneut versuchen',
  'cloud.confirmed': 'E-Mail-Adresse bestätigt. Willkommen bei Tablo!',
  'cloud.resetTitle': 'Neues Passwort',
  'cloud.resetIntro': 'Wählen Sie das neue Passwort für Ihr Konto. Ihre anderen Geräte werden abgemeldet.',
  'cloud.passwordTooShort': 'Passwort zu kurz: mindestens 8 Zeichen.',
  'cloud.newPassword': 'Neues Passwort',
  'cloud.resetSave': 'Speichern und anmelden',
  'cloud.resetExpired':
    'Dieser Link ist abgelaufen oder wurde bereits verwendet. Fordern Sie über „Passwort vergessen?“ einen neuen an.',
  'cloud.signedInAs': 'Angemeldet:',
  'cloud.logout': 'Abmelden',
  'cloud.deleteAccount': 'Konto löschen…',
  'cloud.deleteTitle': 'Ihr Konto löschen',
  'cloud.deleteIntro': 'Damit werden das Konto {email} und seine Daten endgültig vom Tablo-Server gelöscht:',
  'cloud.deleteWhat':
    'Ihre Online-Projekte in Ihrem persönlichen Arbeitsbereich und in den Arbeitsbereichen, deren einziges Mitglied Sie sind, mit ihren Fotos, Dateien, Verlauf, Freigabelinks und Vorlagen, sowie Ihre Wiederherstellungskopien;',
  'cloud.deleteShared':
    'in mit anderen geteilten Arbeitsbereichen bleiben die Projekte beim Team; waren Sie der einzige Eigentümer, wird ein anderes Mitglied Eigentümer;',
  'cloud.deleteLocal':
    'auf diesem Gerät gespeicherte Projekte bleiben dort. Um ein Online-Projekt zu behalten, öffnen Sie es und speichern Sie es zuerst als .tablo-Datei.',
  'cloud.deletePassword': 'Ihr Passwort zur Bestätigung',
  'cloud.deleteConfirm': 'Mein Konto endgültig löschen',
  'cloud.deleteWrongPassword': 'Falsches Passwort.',
  'cloud.deleteOffline': 'Keine Verbindung zum Server: Das Konto kann nur online gelöscht werden.',
  'cloud.deleted': 'Ihr Konto und seine Online-Daten wurden gelöscht.',
  'cloud.workspace': 'Arbeitsbereich',
  'cloud.newWorkspace': 'Neuer Team-Arbeitsbereich…',
  'cloud.create': 'Erstellen',
  'cloud.tab.projects': 'Projekte',
  'cloud.tab.members': 'Mitglieder',
  'cloud.tab.templates': 'Team-Vorlagen',
  'cloud.upload': 'Aktuelles Projekt in „{name}“ speichern',
  'cloud.noProjects': 'Keine Projekte in diesem Arbeitsbereich.',
  'cloud.untitled': 'Ohne Titel',
  'cloud.personal':
    'Persönlicher Arbeitsbereich: Erstellen Sie einen Team-Arbeitsbereich, um gemeinsam zu arbeiten.',
  'cloud.role.owner': 'Eigentümer',
  'cloud.role.editor': 'Bearbeiter',
  'cloud.role.viewer': 'Betrachter',
  'cloud.remove': 'Entfernen',
  'cloud.addMember': 'Hinzufügen',
  'cloud.rolesHint':
    'Bearbeiter ändern Projekte. Betrachter sehen sie an. Eigentümer verwalten zusätzlich die Mitglieder. Die Person muss zuerst ihr Konto erstellen.',
  'cloud.saveTemplate': 'Aktuelles Projekt als Team-Vorlage speichern',
  'cloud.noTemplates': 'Keine Team-Vorlagen.',
  'cloud.brandTitle': 'Ihre Pläne,\nauf jeder Baustelle.',
  'cloud.brand1': 'Online gespeichert und zwischen Computer, Tablet und Smartphone synchronisiert',
  'cloud.brand2': 'Gemeinsam in einem Team-Arbeitsbereich arbeiten',
  'cloud.brand3': 'Nur-Lese-Link für den Kunden und die Kontrollstelle',
  'cloud.dataEurope': 'Daten in Europa gehostet',
  'cloud.loginTitle': 'Bei Tablo anmelden',
  'cloud.registerTitle': 'Tablo-Konto erstellen',
  'cloud.loginIntro': 'Willkommen zurück. Melden Sie sich an, um Ihre Online-Projekte zu finden.',
  'cloud.noAccount': 'Noch kein Konto?',
  'cloud.haveAccount': 'Bereits ein Konto?',
  'cloud.showPassword': 'Passwort anzeigen',
  'cloud.hidePassword': 'Passwort verbergen',
  'cloud.workspaces': 'Arbeitsbereiche',
  'cloud.searchProjects': 'Projekte suchen',
  'cloud.uploadHere': 'Aktuelles Projekt hier speichern',
  'cloud.col.project': 'Projekt',
  'cloud.col.updated': 'Geändert',
  'cloud.col.by': 'Von',
  'cloud.col.template': 'Vorlage',
  'cloud.openNow': 'geöffnet',
  'cloud.noMatch': 'Kein Projekt entspricht „{q}“.',
  'cloud.you': 'Sie',
  'cloud.liveIn': 'Projekt online geöffnet in „{name}“',
  'cloud.liveOffline': 'Offline: Änderungen werden gesendet, sobald die Verbindung wieder besteht',
  'cloud.menuProjects': 'Online-Projekte…',
  'cloud.menuMembers': 'Mitglieder…',
  'cloud.menuTemplates': 'Team-Vorlagen…',
  'cloud.accountMenu': 'Konto',
  'cloud.emailPlaceholder': 'name@firma.be',
  'cloud.roleOf': 'Rolle von',
  'cloud.memberEmail': 'E-Mail des neuen Mitglieds',
  'cloud.synced': '☁ Synchronisiert',
  'cloud.syncing': '☁ Wird gesendet… ({n})',
  'cloud.offline': '☁ Offline · {n} Änderung(en) ausstehend',
  'cloud.with': 'mit {names}',
  'cloud.readOnly': 'schreibgeschützt',
  'cloud.rejected':
    'Änderung „{label}“ rückgängig gemacht: Ein anderer Benutzer hat diese Elemente geändert.',
  'cloud.error': 'Serverfehler: {msg}',
  'cloud.uploaded': 'Projekt in „{name}“ gespeichert; Änderungen werden synchronisiert.',
  'cloud.teamLibrary': 'Team-Bibliothek',
  'cloud.shareToTeam': 'Meine Symbole und Makros mit dem Team teilen',
  'cloud.sharedToTeam': 'Symbole und Makros mit „{name}“ geteilt',
  'share.menu': 'Teilen…',
  'share.title': 'Schreibgeschützt teilen',
  'share.intro':
    'Über einen Link können der Kunde, der Architekt oder die Kontrollstelle die Pläne ansehen und herunterladen, ohne Konto und ohne sie zu ändern.',
  'share.live': 'Immer die neueste Version',
  'share.atRevision': 'Eingefroren auf Revision {index}',
  'share.create': 'Link erstellen',
  'share.none': 'Keine Links für dieses Projekt.',
  'share.copy': 'Kopieren',
  'share.handover': 'Übergabepaket (PDF + QR-Code)',
  'share.revoke': 'Deaktivieren',
  'viewer.status': 'Schreibgeschützt (geteilter Link)',
  'viewer.live': 'Geteilte Pläne — schreibgeschützt',
  'viewer.revision': 'Pläne auf Revision {index} — schreibgeschützt',
  'viewer.download': 'PDF herunterladen',
  'viewer.error': 'Ungültiger Freigabelink: {msg}',
  'dxf.title': 'DXF-Plan importieren',
  'dxf.info': 'DXF-Datei {version} · {w} × {h} m',
  'dxf.units': 'Zeichnungseinheit',
  'dxf.unitsStated': 'in der Datei angegeben',
  'dxf.unitsGuessed': 'aus der Größe geschätzt: bitte prüfen',
  'dxf.scale': 'Maßstab',
  'dxf.paperSize': 'Auf dem Blatt: {w} × {h} mm',
  'dxf.tooBig': 'Größer als die Zeichenfläche: Wählen Sie einen kleineren Maßstab oder ein A3-Blatt.',
  'dxf.layers': 'Layer',
  'dxf.layerCount': '{n} Element(e)',
  'dxf.hiddenLayer': 'in der Datei ausgeblendet',
  'dxf.all': 'Alle',
  'dxf.none': 'Keine',
  'dxf.import': 'Importieren',
  'dxf.strays': '{n} isolierte(s) Element(e) weit von der Zeichnung entfernt ausgelassen.',
  'dxf.skipped': 'Nicht importiert: {list}.',
  'dxf.dwg':
    'DWG-Datei (AutoCAD {version}): Dieses geschlossene Format kann nicht direkt gelesen werden. Speichern Sie sie in Ihrer CAD-Software als DXF (Speichern unter → DXF) oder konvertieren Sie sie mit dem ODA File Converter (kostenlos) und importieren Sie dann die DXF-Datei.',
  'dxf.binary': 'Binäres DXF wird nicht unterstützt: Speichern Sie es erneut als ASCII-DXF (Text).',
  'dxf.notDxf': 'Diese Datei ist keine lesbare DXF-Datei.',
  'dxf.empty': 'Auf den gewählten Layern gibt es nichts zu importieren.',
  'dxf.trueScale': 'Der Plan ist im echten Maßstab: Der Maßstab muss nicht festgelegt werden.',
  'quote.menu': 'Angebot und Materialliste (Excel)…',
  'quote.title': 'Angebot und Materialliste',
  'quote.intro':
    'Material aus den Einliniendiagrammen, Kabel aus den Stromkreislängen und eine Zeile für Arbeitsleistung. Die Preise stammen aus Ihrer Preisliste (Großhändler); alles bleibt in der Datei bearbeitbar.',
  'quote.priceList': 'Preisliste',
  'quote.importPrices': 'Preisliste importieren (CSV, Excel)…',
  'quote.priceListInfo': '{name} · {n} Preise',
  'quote.noPriceList': 'Keine Preisliste: Die Preise sind in der Datei auszufüllen.',
  'quote.removePrices': 'Entfernen',
  'quote.noPrices': 'Keine Preise gefunden: Die Liste benötigt eine Referenz- und eine Preisspalte.',
  'quote.vat': 'MwSt.',
  'quote.vat6': '6 % (Renovierung einer über 10 Jahre alten Wohnung)',
  'quote.vat21': '21 %',
  'quote.waste': 'Kabelverschnitt (%)',
  'quote.discount': 'Rabatt auf Material (%)',
  'quote.missingLengths': 'Kabel nicht gezählt für {n} Stromkreis(e) ohne Länge: {list}.',
  'quote.lines': '{n} Zeile(n), davon {priced} mit Preis',
  'quote.totals': 'Summe exkl. MwSt. {sub} · MwSt. {vat} · inkl. MwSt. {total}',
  'quote.xlsx': 'Excel (.xlsx)',
  'quote.csv': 'CSV',
  'quote.fromSurvey':
    'Die Aufnahme hat noch keine Pläne erzeugt: Erzeugen Sie sie, damit das Angebot ihr Material enthält.',
  'quote.file': 'angebot',
  'quote.colRef': 'Ref.',
  'quote.colDesc': 'Beschreibung',
  'quote.colQty': 'Menge',
  'quote.colPrice': 'Stückpreis',
  'quote.colSource': 'Quelle',
  'quote.sourceStale':
    '{name}: Die letzte Aktualisierung ist fehlgeschlagen; es werden die Preise vom {date} verwendet.',
  'quote.serverPricesDown':
    'Die Großhändlerpreise konnten nicht geladen werden (keine Verbindung): Angebot mit den anderen Quellen kalkuliert.',
  'quote.sourceReference': 'Tablo-Referenzpreise (Belgien)',
  'quote.sourceUpdated': 'aktualisiert am {date}',
  'quote.sourceOrder': 'Reihenfolge bei fehlendem Preis: {list}',
  'quote.preferredSource': 'Bevorzugte Preisquelle',
  'quote.downloadPrices': 'Preise herunterladen (Excel)…',
  'quote.priceListFile': 'Tablo Preise.xlsx',
  'quote.useLibrary': 'Fehlende Preise aus den belgischen Referenzpreisen ergänzen (geprüft am {date})',
  'quote.libraryPrice':
    'Die Tablo-Referenzpreise sind öffentliche Listenpreise exkl. MwSt.: Die Preise Ihres Großhändlers sind niedriger.',
  'quote.labourHours': 'Arbeitsleistung (Stunden)',
  'survey.mode': 'Aufnahme vor Ort',
  'survey.menu': 'Aufnahme vor Ort (Smartphone, Tablet)',
  'survey.homeTitle': 'Aufnahmen',
  'survey.intro':
    'Erfassen Sie die Anlage Raum für Raum und fotografieren Sie den Verteiler: Tablo macht daraus das Einliniendiagramm und die Lagepläne. Funktioniert ohne Netz.',
  'survey.new': 'Neue Aufnahme',
  'survey.newTitle': 'Aufnahme {date}',
  'survey.current': 'Geöffnetes Projekt',
  'survey.continue': 'Fortsetzen',
  'survey.onDevice': 'Auf diesem Gerät',
  'survey.cloudTeam': 'Cloud — {team}',
  'survey.noProjects': 'Keine Projekte auf diesem Gerät.',
  'survey.offlineCopy': 'Offline-Kopie',
  'survey.cloudBadge': 'Cloud',
  'survey.remove': 'Von diesem Gerät entfernen',
  'survey.removeConfirm': '„{name}“ von diesem Gerät entfernen? Ein Cloud-Projekt bleibt auf dem Server.',
  'survey.signIn': 'In der Cloud anmelden',
  'survey.install': 'App installieren',
  'survey.installIos': 'Zum Installieren: Teilen-Taste, dann „Zum Home-Bildschirm“.',
  'survey.storageWarn':
    'Installieren Sie die App: Sonst kann der Browser die auf diesem Gerät gespeicherten Aufnahmen löschen.',
  'survey.openEditor': 'Im Editor öffnen',
  'survey.back': 'Zurück',
  'survey.tabRooms': 'Räume',
  'survey.tabBoard': 'Verteiler',
  'survey.tabChecks': 'Prüfungen',
  'survey.tabInfo': 'Projekt',
  'survey.addRoom': 'Raum hinzufügen',
  'survey.roomName': 'Raumname',
  'survey.roomType': 'Raumtyp',
  'survey.level': 'Etage',
  'survey.noRooms': 'Beginnen Sie mit dem Raum, in dem Sie sich befinden.',
  'survey.points': 'Punkte',
  'survey.morePoints': 'Weitere Punkte…',
  'survey.noPoints': 'Keine Punkte in diesem Raum: Fügen Sie sie unten hinzu.',
  'survey.circuit': 'Stromkreis',
  'survey.noCircuit': 'Kein Stromkreis',
  'survey.chooseCircuit': 'Stromkreis dieser Punkte',
  'survey.newCircuit': 'Neuer Stromkreis',
  'survey.notes': 'Notizen',
  'survey.photos': 'Fotos',
  'survey.takePhoto': 'Foto',
  'survey.fromGallery': 'Galerie',
  'survey.removePhoto': 'Foto löschen',
  'survey.deleteRoom': 'Raum löschen',
  'survey.deleteRoomConfirm': '„{name}“ und seine Punkte löschen?',
  'survey.pointCount': '{n} Punkt(e)',
  'survey.unassigned': '{n} ohne Stromkreis',
  'survey.addBoard': 'Verteiler hinzufügen',
  'survey.mainBoard': 'Hauptverteiler',
  'survey.boardName': 'Name des Verteilers',
  'survey.boardPhotos': 'Fotos des Verteilers',
  'survey.readBoard': 'Verteiler ablesen (KI)',
  'survey.reading': 'Foto wird gelesen…',
  'survey.readResult': '{circuits} Stromkreis(e) und {rcds} FI erkannt.',
  'survey.readApply': 'Verteiler ausfüllen',
  'survey.readKeeps':
    'Bereits erfasste Stromkreise werden der Reihe nach aktualisiert und behalten ihre Punkte.',
  'survey.readError': 'Lesen nicht möglich: {msg}',
  'survey.mainSwitch': 'Hauptschalter',
  'survey.mainRcd': 'Haupt-FI',
  'survey.none': 'Keiner',
  'survey.rcds': 'FI-Schutzschalter',
  'survey.addRcd': 'FI hinzufügen',
  'survey.rcdLabel': 'FI {ma} mA',
  'survey.mainBus': 'Direkt unter dem Hauptschalter',
  'survey.circuits': 'Stromkreise',
  'survey.addCircuit': 'Stromkreis hinzufügen',
  'survey.circuitLabel': 'Bezeichnung',
  'survey.circuitLabelPh': 'z. B. Steckdosen Küche',
  'survey.device': 'Schutz',
  'survey.devMCB': 'LS',
  'survey.devRCBO': 'FI/LS',
  'survey.devFuse': 'Sicherung',
  'survey.rating': 'Nennstrom (A)',
  'survey.curve': 'Kennlinie',
  'survey.poles': 'Pole',
  'survey.section': 'Querschnitt (mm²)',
  'survey.cableType': 'Kabel',
  'survey.cores': 'Adern',
  'survey.length': 'Länge (m)',
  'survey.rcdOf': 'FI',
  'survey.legacy': 'Altanlage (vor dem 1. Oktober 1981)',
  'survey.circuitPoints': 'Versorgte Punkte',
  'survey.deleteCircuit': 'Stromkreis löschen',
  'survey.deleteCircuitConfirm': 'Stromkreis {code} löschen? Seine Punkte bleiben ohne Stromkreis erhalten.',
  'survey.deleteBoard': 'Verteiler löschen',
  'survey.deleteBoardConfirm': '„{name}“ und seine Stromkreise löschen?',
  'survey.deleteRcd': 'FI löschen',
  'survey.earth': 'Erder',
  'survey.earthOhm': 'Gemessener Widerstand (Ω)',
  'survey.sensitivity': 'Empfindlichkeit (mA)',
  'survey.rcdType': 'Typ',
  'survey.checksOk': 'Nichts zu melden.',
  'survey.fromDiagram': '{std}-Regel, auf den zu erzeugenden Plänen',
  'survey.generate': 'Pläne erzeugen',
  'survey.regenerate': 'Pläne aktualisieren',
  'survey.generated': '{n} Blatt/Blätter aus der Aufnahme erzeugt.',
  'survey.stale': 'Die Aufnahme wurde seit dem Erzeugen der Pläne geändert.',
  'survey.upToDate': 'Die Pläne entsprechen der Aufnahme.',
  'survey.notGenerated':
    'Noch keine Pläne: Erzeugen Sie sie, wenn die Aufnahme vollständig ist (oder jetzt, zur Ansicht).',
  'survey.regenerateWarn':
    'Aus der Aufnahme erzeugte Blätter werden ersetzt: Manuelle Änderungen darauf gehen verloren.',
  'survey.statusSaved': 'Gespeichert',
  'survey.statusSynced': 'Synchronisiert',
  'survey.statusPending': 'Zu senden: {n}',
  'survey.statusOffline': 'Offline',
  'survey.statusFiles': 'Zu sendende Fotos: {n}',
  'survey.statusFile': 'Datei {name}',
  'survey.keepOnDevice': 'Auf diesem Gerät behalten',
  'survey.kept': 'Projekt auf diesem Gerät behalten.',
  'survey.pdf': 'PDF der Pläne',
  'survey.quantity': 'Anzahl',
  'survey.deletePoint': 'Löschen',
  'survey.upload': 'In die Cloud stellen ({team})',
  'survey.cloudSection': 'Cloud',
  'survey.inCloud': 'In der Cloud — {team}',
  'survey.done': 'OK',
  'menu.inspection': 'Kontrolle',
  'panel.photos': 'Fotos',
  'quote.invoice': 'Rechnung…',
  'survey.measure': 'Messergebnisse eingeben',
  'survey.pointPhotos': 'Fotos des Punktes ({n})',
  'measure.menu': 'Messergebnisse…',
  'measure.earth': 'Erder',
  'measure.earthOhm': 'Erdungswiderstand (Ω)',
  'measure.title': 'Messergebnisse',
  'measure.intro':
    'Eine Karte pro Stromkreis und pro FI des Schemas. Jeder Wert wird sofort bei der Eingabe mit seinem Grenzwert verglichen; die R-TEST-Regeln melden, was nicht besteht oder fehlt.',
  'measure.date': 'Prüfdatum',
  'measure.circuits': 'Stromkreise',
  'measure.rcds': 'FI-Schutzschalter',
  'measure.insulation': 'Isolationswiderstand (MΩ)',
  'measure.testVoltage': 'Prüfspannung',
  'measure.continuity': 'Durchgängigkeit PE (Ω)',
  'measure.loop': 'Fehlerschleife Zs (Ω)',
  'measure.noLimit': 'Sicherung: kein Grenzwert',
  'measure.tripMs': 'Auslösezeit (ms)',
  'measure.tripMa': 'Auslösestrom (mA)',
  'measure.testButton': 'Prüftaste',
  'measure.trips': 'Löst aus',
  'measure.noTrip': 'Löst nicht aus',
  'measure.nothing':
    'Kein Stromkreis oder FI im Schema: Zeichnen oder erzeugen Sie zuerst das Einliniendiagramm.',
  'measure.progress': '{m}/{c} Stromkreise gemessen · {r}/{n} FI geprüft · {f} nicht bestanden',
  'measure.csv': 'Exportieren (CSV)',
  'measure.file': 'Messergebnisse',
  'measure.tx': 'Messung {ref}',
  'inspection.menu': 'Kontrollberichte und Bemerkungen…',
  'inspection.title': 'Kontrollberichte',
  'inspection.read': 'Bericht einlesen (Foto oder PDF)…',
  'inspection.reading': 'Bericht wird gelesen…',
  'inspection.readFailed': 'Bericht konnte nicht gelesen werden: {error}',
  'inspection.manual': 'Manuell eingeben',
  'inspection.none':
    'Noch kein Kontrollbericht für dieses Projekt. Lesen Sie den Bericht der zugelassenen Kontrollstelle ein oder geben Sie die Bemerkungen manuell ein.',
  'inspection.pick': 'Bericht',
  'inspection.body': 'Zugelassene Kontrollstelle',
  'inspection.reference': 'Berichtsnummer',
  'inspection.date': 'Datum des Besuchs',
  'inspection.inspector': 'Prüfer',
  'inspection.result': 'Ergebnis',
  'inspection.conform': 'Konform',
  'inspection.notConform': 'Nicht konform',
  'inspection.deadline': 'Frist für die Arbeiten',
  'inspection.pages': 'Seiten des Berichts',
  'inspection.remarksFound':
    '{n} Bemerkung(en) gelesen — entfernen Sie das Häkchen bei denen, die ausgelassen werden sollen',
  'inspection.addToProject': 'Zum Projekt hinzufügen ({n})',
  'inspection.txAdd': 'Kontrollbericht',
  'inspection.remarks': 'Bemerkungen — {open} von {n} zu beheben',
  'inspection.remarksTitle': 'Bemerkungen der Kontrolle',
  'inspection.openCount': '{n} von {total} zu beheben',
  'inspection.pack': 'Unterlagen für die Nachkontrolle (PDF)',
  'inspection.packFile': 'Nachkontrolle',
  'inspection.delete': 'Bericht löschen',
  'inspection.deleteConfirm': 'Der Bericht und seine {n} Bemerkung(en) werden aus dem Projekt entfernt.',
  'remark.one': 'Bemerkung',
  'remark.add': 'Bemerkung hinzufügen',
  'remark.open': 'Zu beheben',
  'remark.fixed': 'Behoben',
  'remark.text': 'Bemerkung',
  'remark.article': 'Artikel',
  'remark.ref': 'Stromkreis oder Punkt',
  'remark.fixNote': 'Durchgeführte Maßnahme',
  'remark.fixNoteHint': 'Z. B. FI 30 mA Typ A an Stromkreis B hinzugefügt',
  'remark.photos': 'Fotos der Behebung',
  'remark.delete': 'Bemerkung löschen',
  'invoice.menu': 'Rechnungen…',
  'invoice.title': 'Rechnungen',
  'invoice.intro':
    'Ausgestellte Rechnungen bleiben im Projekt und werden danach nicht mehr geändert. Jede wird als PDF (mit Zahlungs-QR-Code) und, zwischen Unternehmen, als Peppol-Datei (UBL) für die in Belgien seit 2026 vorgeschriebene E-Rechnung heruntergeladen.',
  'invoice.none': 'Noch keine Rechnung für dieses Projekt.',
  'invoice.new': 'Neue Rechnung',
  'invoice.creditNote': 'Gutschrift…',
  'invoice.newCreditNote': 'Neue Gutschrift',
  'invoice.kindCredit': 'Gutschrift',
  'invoice.creditFor':
    'Gutschrift zur Rechnung {n} vom {date}: Entfernen Sie die Zeilen oder senken Sie die Mengen, die nicht gutgeschrieben werden.',
  'invoice.creditHint': 'Diese Rechnung korrigieren oder stornieren (ganz oder teilweise)',
  'invoice.kindDeposit': 'Anzahlung',
  'invoice.depositPct': 'Anzahlung (%)',
  'invoice.makeDeposit': 'Anzahlungsrechnung erstellen',
  'invoice.depositHint':
    'Ersetzt die Zeilen durch eine Zeile: diesen Anteil ihrer Summe, zu ihrem MwSt.-Satz. Die Schlussrechnung zieht ihn ab.',
  'invoice.depositLine': 'Anzahlung {pct} % — {ref}',
  'invoice.depositDeducted': 'In Rechnung gestellte Anzahlung (Rechnung {n} vom {date})',
  'invoice.deductDeposits': 'Anzahlungsrechnungen abziehen ({n})',
  'invoice.isDeposit': 'Anzahlungsrechnung: Die Schlussrechnung zieht sie ab.',
  'invoice.vatPart': 'MwSt. {pct} % auf {base}: {vat}',
  'invoice.seriesTeam':
    'Bei Ausstellung vom Arbeitsbereich „{team}“ nummeriert: eine Serie für die ganze Firma.',
  'invoice.seriesOffline':
    'Die Nummer kommt vom Arbeitsbereich „{team}“: Verbinden Sie sich, um auszustellen.',
  'invoice.seriesStart':
    'Neue Rechnungsserie {prefix} für „{team}“. Setzen Sie eine bestehende Nummerierung fort? Nächste Nummer:',
  'invoice.seriesStartLabel': 'Nächste Nummer der Serie',
  'invoice.seriesSet': 'Festlegen',
  'invoice.emailAction': 'Per E-Mail…',
  'invoice.emailTitle': '{n} per E-Mail an den Kunden senden',
  'invoice.emailTo': 'An',
  'invoice.emailMessage': 'Ihre Nachricht (optional)',
  'invoice.emailXml': 'Peppol-Datei anhängen (Firmenkunde)',
  'invoice.emailReply':
    'Von der Adresse von Tablo in Ihrem Namen gesendet; Antworten des Kunden gehen an {email}.',
  'invoice.emailAccount': 'die Adresse Ihres Kontos',
  'invoice.emailSend': 'Senden',
  'invoice.emailSent': '{n} an {to} gesendet.',
  'invoice.emailFailed': 'Nicht gesendet: {msg}',
  'billit.pitch': 'Stellen Sie Ihre Rechnungen über Peppol zu und verfolgen Sie ihre Zahlung mit Billit:',
  'billit.connect': 'Mit Billit verbinden',
  'billit.waiting': 'Warten auf Billit…',
  'billit.connectedTo': 'Mit Billit verbunden: Übergeben Sie Ihre Rechnungen aus der Liste.',
  'billit.disconnect': 'Trennen',
  'billit.title': '{n} an Billit übergeben',
  'billit.explain':
    'Die Rechnung geht unverändert in Ihr Billit-Konto (gleiche Nummer, Zeilen und PDF). Billit stellt sie zu, verfolgt ihre Zahlung und gibt sie an Ihren Buchhalter weiter.',
  'billit.peppolNow': 'Jetzt über Peppol zustellen',
  'billit.noPeppol':
    'Nicht über Peppol (Privatkunde oder Peppol-IDs fehlen): Billit bewahrt sie zum Versand für Sie auf',
  'billit.send': 'An Billit senden',
  'billit.sent': '{n} ist in Billit.',
  'billit.sentPeppol': '{n} ist in Billit und über Peppol unterwegs.',
  'billit.failed': 'Billit: {msg}',
  'billit.tx': 'Rechnung {n} an Billit übergeben',
  'billit.statusHint': 'Status bei Billit abrufen',
  'billit.paid': 'bezahlt',
  'billit.status.ToSend': 'zu senden',
  'billit.status.ToPay': 'gesendet, zu bezahlen',
  'billit.status.Paid': 'bezahlt',
  'billit.connectedNotice': 'Mit Billit verbunden.',
  'billit.failedNotice': 'Billit wurde nicht verbunden: Versuchen Sie es erneut über die Rechnungen.',
  'invoice.problem.negativeTotal': 'Die Summe ist negativ: Erstellen Sie stattdessen eine Gutschrift.',
  'invoice.problem.negativePrice':
    'Ein Stückpreis ist negativ: Verwenden Sie eine negative Menge, um einen Betrag abzuziehen.',
  'invoice.issue': 'Rechnung ausstellen',
  'invoice.txIssue': 'Rechnung {n}',
  'invoice.duplicate': 'Die Nummer {n} wird in diesem Projekt bereits verwendet.',
  'invoice.file': 'Rechnung',
  'invoice.seller': 'Ihre Angaben',
  'invoice.sellerKept': '(auf diesem Gerät gespeichert)',
  'invoice.buyer': 'Kunde',
  'invoice.buyerHint':
    'Privatkunde: MwSt.-Nummer leer lassen, die Rechnung geht als PDF. Unternehmen: Seine Unternehmensnummer ist seine Peppol-ID (0208).',
  'invoice.details': 'Rechnung',
  'invoice.name': 'Name',
  'invoice.vatNumber': 'MwSt.-Nummer',
  'invoice.street': 'Straße und Hausnummer',
  'invoice.postcode': 'Postleitzahl',
  'invoice.city': 'Ort',
  'invoice.country': 'Land',
  'invoice.email': 'E-Mail',
  'invoice.peppolId': 'Peppol-ID (optional)',
  'invoice.number': 'Nr.',
  'invoice.vat': 'MwSt.',
  'invoice.reverseCharge': 'Verlagerung der Steuerschuld (Vertragspartner)',
  'invoice.issueDate': 'Datum',
  'invoice.dueDate': 'Fälligkeitsdatum',
  'invoice.orderRef': 'Referenz des Kunden (Bestellung, Angebot)',
  'invoice.paymentRef': 'Strukturierte Mitteilung',
  'invoice.note': 'Vermerk',
  'invoice.lines': 'Zeilen',
  'invoice.addQuoteLines': 'Zeilen des Angebots hinzufügen',
  'invoice.addLine': 'Zeile',
  'invoice.unit': 'Einheit',
  'invoice.unit.C62': 'Stück',
  'invoice.unit.MTR': 'Meter',
  'invoice.unit.HUR': 'Stunde',
  'invoice.amount': 'Betrag',
  'invoice.total': 'Summe inkl. MwSt.',
  'invoice.peppolReady':
    '✓ Bereit für Peppol: Die UBL-Datei kann über Ihren Peppol-Zugangspunkt oder das Hermes-Portal gesendet werden.',
  'invoice.pdfOnly': 'PDF-Rechnung (Kunde ohne belgische Unternehmensnummer: kein Versand über Peppol).',
  'invoice.peppolHint': 'Datei Peppol BIS Billing 3.0 (UBL) zum Versand über Ihren Zugangspunkt',
  'invoice.peppolMissing': 'Der Kunde hat keine Peppol-ID (belgische Unternehmensnummer)',
  'invoice.problem.sellerName': 'Ihr Name fehlt.',
  'invoice.problem.sellerVat': 'Ihre MwSt.-Nummer fehlt oder ist ungültig.',
  'invoice.problem.sellerAddress': 'Ihre Adresse ist unvollständig.',
  'invoice.problem.sellerIban': 'Die IBAN ist ungültig.',
  'invoice.problem.buyerName': 'Der Name des Kunden fehlt.',
  'invoice.problem.buyerAddress': 'Die Adresse des Kunden fehlt.',
  'invoice.problem.buyerVatReverse':
    'Die Verlagerung der Steuerschuld erfordert die MwSt.-Nummer des Kunden.',
  'invoice.problem.buyerVat': 'Die MwSt.-Nummer des Kunden ist ungültig.',
  'invoice.problem.noLines': 'Die Rechnung hat keine Zeilen.',
  'invoice.problem.lineDescription': 'Eine Zeile hat keine Beschreibung.',
  'invoice.problem.number': 'Die Rechnungsnummer fehlt.',
  'invoice.problem.dates': 'Die Daten sind ungültig (Fälligkeitsdatum vor dem Rechnungsdatum?).',
  'invoice.problem.paymentRef': 'Die strukturierte Mitteilung ist ungültig.',
  'tour.menu': 'Geführtes Tutorial',
  'tour.welcome': 'Geführte Tour starten',
  'tour.begin': 'Starten',
  'tour.next': 'Weiter',
  'tour.back': 'Zurück',
  'tour.replay': 'Erneut zeigen',
  'tour.skipDemo': 'Demo überspringen',
  'tour.restart': 'Neu beginnen',
  'tour.finish': 'Beenden',
  'tour.close': 'Tutorial schließen',
  'tour.playPart': 'Diesen Teil erneut zeigen',
  'tour.prevPart': 'Vorheriger Teil',
  'tour.nextPart': 'Nächster Teil',
  'tour.cap.aiBoard': 'Verteiler von einem Foto ablesen',
  'tour.cap.ib': 'Betriebsstrom des Beleuchtungsstromkreises',
  'tour.sample.circuit': 'Küche',
  'side.label': 'Seitenleiste',
  'side.fold': 'Seitenleiste einklappen',
  'side.unfold': 'Seitenleiste ausklappen',
  'palette.fold': 'Symbolbereich einklappen',
  'palette.unfold': 'Symbolbereich ausklappen',
  'side.assistant': 'KI-Assistent',
  'side.selectHint':
    'Klicken Sie auf ein Symbol oder eine Leitung auf dem Blatt, um hier seine Eigenschaften zu sehen und zu ändern.',
  'side.assistHint':
    'Beschreiben Sie eine Änderung in eigenen Worten, zum Beispiel „Ladestation für E-Auto an 32 A hinzufügen, dann das Mehrliniendiagramm erzeugen“. Sie sehen, was sich ändert, bevor Sie es übernehmen.',
  'side.assistSignedOut':
    'Der Assistent ändert den Plan nach einer Anfrage in Ihren eigenen Worten. Melden Sie sich an, um ihn zu nutzen.',
  'tour.area.assistant': 'Der KI-Assistent',
  'tour.area.rail': 'Ein Symbol pro Bereich',
  'tour.cap.assistant': 'Geöffnet über KI → Assistent',
  'tour.cap.assistSend': 'Senden, dann den Vorschlag prüfen',
  'tour.cap.assistSignIn': 'Der Assistent benötigt ein Konto',
  'tour.sample.assist': 'Ladestation für E-Auto an 32 A hinzufügen, dann das Mehrliniendiagramm erzeugen',
  'tour.tipLabel': 'Gute Praxis',
  'tour.chapter': 'Teil {n}/{total}',
  'tour.ch1': 'Ein Projekt beginnen',
  'tour.ch2': 'Von Hand zeichnen',
  'tour.ch3': 'Die Stromkreistabelle',
  'tour.ch4': 'Die Prüfung',
  'tour.ch5': 'Weitere Pläne',
  'tour.ch6': 'Speichern und übergeben',
  'tour.sample.title': 'Haus Schmitz',
  'tour.sample.owner': 'Marie Schmitz',
  'tour.sample.address': 'Bahnhofstraße 12, 4700 Eupen',
  'tour.area.toolbar': 'Menüs und Werkzeuge',
  'tour.area.palette': 'Symbole',
  'tour.area.canvas': 'Das Blatt',
  'tour.area.inspector': 'Seitenleiste: Auswahl, KI-Assistent, Blatt',
  'tour.area.sheets': 'Blätter',
  'tour.area.status': 'Status und Prüfzähler',
  'tour.cap.template': 'Haus, Wohnung oder Werkstatt, fertig vorbereitet',
  'tour.cap.survey': 'Aus Ihrer Aufnahme vor Ort',
  'tour.cap.example': 'Ein vollständiges Haus zum Erkunden',
  'tour.cap.standard': 'Die Regeln, die die Prüfung anwendet',
  'tour.cap.locale': 'Die Sprache der Pläne',
  'tour.cap.icc': 'Nötig zur Prüfung des Schaltvermögens',
  'tour.cap.titleBlock': 'Das Schriftfeld füllt sich selbst',
  'tour.cap.search': 'Ein Symbol nach Namen suchen',
  'tour.cap.tag': 'Automatisch als W1 gekennzeichnet',
  'tour.cap.label': 'Die Beschriftung folgt den Eigenschaften',
  'tour.cap.drop': 'Spannungsfall gegenüber seinem Grenzwert',
  'tour.cap.codes': 'Stromkreiscodes in Reihenfolge',
  'tour.cap.statusChecks': 'Immer sichtbar',
  'tour.cap.banner': 'Aus dem Einliniendiagramm erzeugt',
  'tour.cap.sheetKinds': 'Blattarten',
  'tour.cap.revisions': 'Revision A, B… einfrieren',
  'tour.cap.exportFull': 'Das vollständige Übergabe-PDF',
  'tour.cap.quote': 'Angebot und Materialliste',
  'tour.cap.cloud': 'Synchronisation, Team und Teilen',
  'tour.intro.title': 'Zeichnen Sie Ihre erste Anlage',
  'tour.intro.body':
    'In etwa zehn Minuten beginnen Sie ein Projekt und zeichnen ein kleines Einliniendiagramm; den Rest erledigt Tablo: Stromkreise, Berechnungen, die AREI-Prüfung und das Mehrliniendiagramm.\nJeder Schritt **hebt** einen Teil des Bildschirms **hervor** und zeigt ihn, Teil für Teil: Die Pfeile **‹ ›** — oder die Tasten **← →** — spielen den vorherigen oder nächsten Teil ab. Am Ende eines Schritts wird jeder Absatz mit seiner guten Praxis aufgelistet; klicken Sie auf einen, um ihn erneut zu sehen. Probieren Sie zwischen den Teilen selbst, dann klicken Sie auf **Weiter**.\nDas Tutorial arbeitet in einem neuen, leeren Projekt: Behalten oder verwerfen Sie es am Ende.',
  'tour.intro.tip':
    'Tablo ist für einen Computer mit Maus und Tastatur gemacht. Auf einem Smartphone öffnet es stattdessen die **Aufnahme vor Ort**: Erfassen Sie Räume und Punkte auf der Baustelle und stellen Sie die Pläne dann hier fertig.',
  'tour.workspace.title': 'Ihr Arbeitsbereich',
  'tour.workspace.p1':
    '**Obere Leiste**: die Menüs (Datei, Schema, Kontrolle, KI), Rückgängig, die Werkzeuge sowie die Bereiche Stromkreise und AREI-Prüfung.',
  'tour.workspace.p2': '**Symbole** links: die Symbole für die Art des aktuellen Blattes.',
  'tour.workspace.p3':
    '**Das Blatt** in der Mitte, ein echter Zeichnungsrahmen mit Schriftfeld. Mausrad oder Zwei-Finger-Geste zum Zoomen, mittlere Taste oder Leertaste + Ziehen zum Verschieben, **F** für alles anzeigen.',
  'tour.workspace.p4':
    'Die **Seitenleiste** rechts besteht aus auf- und zuklappbaren Bereichen: **Auswahl** (die Eigenschaften des Ausgewählten), der **KI-Assistent** und **Blatt** (Name, Art, Papier, Projektinformationen).',
  'tour.workspace.p5':
    'Die Schaltfläche oben klappt die Seitenleiste zu einer Symbolleiste ein, für mehr Platz auf dem Blatt. Klicken Sie auf ein Symbol, um seinen Bereich anzuzeigen; erneut klicken oder auf das Blatt klicken blendet ihn wieder aus.',
  'tour.workspace.p6': '**Blätter** unten, dann die **Statusleiste** mit dem Prüfzähler.',
  'tour.workspace.tip':
    'Lernen Sie früh die Ein-Tasten-Werkzeuge — **V** Auswahl, **W** Leitung, **T** Text, **R** drehen, **F** alles anzeigen. Linke Hand auf der Tastatur, rechte Hand an der Maus ist der schnellste Weg zu zeichnen.',
  'tour.start.title': 'Drei Wege zum Start',
  'tour.start.p1':
    '**Datei → Neu aus Vorlage**: ein Haus, eine Wohnung oder eine Drehstrom-Werkstatt, Verteiler bereits gezeichnet.',
  'tour.start.p2':
    '**Datei → Aufnahme vor Ort**: Was Sie auf dem Smartphone erfasst haben, wird zu den Plänen.',
  'tour.start.p3': '**Datei → Beispiel**: ein vollständiges Haus zum Umsehen.',
  'tour.start.p4':
    '**KI → Foto des Verteilers importieren** liest einen bestehenden Verteiler Gerät für Gerät ab.',
  'tour.start.tip':
    'Beginnen Sie bei einem echten Auftrag nicht mit einem leeren Blatt: Starten Sie mit einer Vorlage oder Ihrer Aufnahme vor Ort und passen Sie dann an. Der Verteiler ist von der ersten Minute an nach AREI aufgebaut.',
  'tour.info.title': 'Zuerst die Projektinformationen',
  'tour.info.p1':
    '**Datei → Projektinformationen** füllt das Schriftfeld jedes Blattes: Projekt, Eigentümer, Adresse der Anlage, Verfasser.',
  'tour.info.p2':
    'Die **Norm** bestimmt, welche Regeln die Prüfung anwendet: AREI, NF C 15-100 oder NEN 1010.',
  'tour.info.p3':
    'Die **Sprache der Pläne** kann von der Oberfläche abweichen: etwa eine deutsche Oberfläche für einen französischsprachigen Kunden.',
  'tour.info.p4':
    'Das Netzsystem, die Versorgungsspannung und der **unbeeinflusste Kurzschlussstrom** am Anfang der Anlage.',
  'tour.info.p5': '**OK**: Das Schriftfeld jedes Blattes füllt sich selbst.',
  'tour.info.tip':
    'Füllen Sie sie vor dem Zeichnen aus. Geben Sie den Kurzschlussstrom am Anfang an, sonst kann das Schaltvermögen nicht geprüft werden, und zeichnen Sie in der Sprache des Kunden: Das lesen der Kunde und der Prüfer.',
  'tour.palette.title': 'Die Symbolpalette',
  'tour.palette.p1':
    'Die Symbole sind nach Familien gruppiert (Verteilung, Schutz, Steckdosen, Beleuchtung…) und nach Blattart gefiltert. Tippen Sie in das Suchfeld, um eines nach Namen zu finden.',
  'tour.palette.p2':
    'Klicken Sie auf ein Symbol, dann auf das Blatt — hier die **Einspeisung**. Sie erhält sofort ihr Kennzeichen W1.',
  'tour.palette.tip':
    'Die Palette bietet nur an, was auf diese Blattart gehört. Aktivieren Sie **Alle Symbole** nur, wenn Sie wirklich eines von woanders brauchen, und erstellen Sie Fehlendes mit **Neues Symbol…** unten, statt es mit losen Linien zu zeichnen.',
  'tour.place.title': 'Die Geräte platzieren',
  'tour.place.p1':
    'Platzieren Sie den Verteiler von oben nach unten: einen **FI** (Q1), einen **LS** (Q2) und eine **Steckdose** (X1). Alles rastet in einem 2,5-mm-Raster ein.',
  'tour.place.p2':
    '**R** dreht und **M** spiegelt das zu platzierende Symbol oder die Auswahl; **Esc** legt das Werkzeug ab.',
  'tour.place.tip':
    'Zeichnen Sie den Verteiler in Leserichtung: Einspeisung, Hauptschalter oder FI, LS, dann die Punkte. Behalten Sie die von Tablo vergebenen Kennzeichen: Das Mehrliniendiagramm, die Stromkreisliste und die Verteilerbeschriftung beruhen darauf.',
  'tour.wire.title': 'Mit Leitungen verbinden',
  'tour.wire.p1':
    'Drücken Sie **W**, klicken Sie auf einen **Anschluss** — das Ende eines Symbols leuchtet auf, wenn Sie darauf sind — dann auf den nächsten Anschluss.',
  'tour.wire.p2':
    'Die Ecken werden für Sie geführt: Verbinden Sie den FI mit dem LS, dann den LS mit der Steckdose.',
  'tour.wire.p3':
    'Klicken Sie auf das freie Raster, um selbst eine Ecke hinzuzufügen; beginnen oder enden Sie auf einer Leitung für eine T-Abzweigung. **Rücktaste** entfernt die letzte Ecke, **Esc** bricht ab.',
  'tour.wire.tip':
    'Beenden Sie eine Leitung immer auf einem Anschluss oder einer anderen Leitung, nie nur daneben. Die Verbindungen — nicht das Bild — werden von Stromkreisen, Berechnungen und Prüfung gelesen: Eine Leitung, die nur verbunden aussieht, ist es nicht.',
  'tour.inspector.title': 'Die Eigenschaften festlegen',
  'tour.inspector.p1':
    'Klicken Sie mit dem Auswahlwerkzeug (**V**) auf ein Gerät: Der Bereich **Auswahl** der Seitenleiste zeigt sein Kennzeichen und alles, was es trägt — Nennstrom, Kennlinie, Empfindlichkeit, Kabel, Katalogreferenz, Fotos.',
  'tour.inspector.p2':
    'Hier wird der LS zu **20 A, Kennlinie C**, und seine Beschriftung auf dem Blatt folgt. Doppelklicken Sie auf ein Gerät, um zu seinem ersten Feld zu springen.',
  'tour.inspector.tip':
    'Geben Sie echte Werte ein, keine Platzhalter. Nennströme, Kennlinien, FI-Empfindlichkeit und Kabel fließen in die Berechnungen und die Prüfung ein: Nichts auf einem Tablo-Plan ist nur Dekoration.',
  'tour.edit.title': 'Verschieben, kopieren, rückgängig machen',
  'tour.edit.p1': 'Ziehen Sie ein Gerät, um es zu verschieben: Seine Leitungen folgen.',
  'tour.edit.p2': '**{mod}Z** macht rückgängig — die Steckdose kehrt zurück. **{mod}⇧Z** stellt wieder her.',
  'tour.edit.p3':
    'Ziehen Sie auf einer freien Fläche, um einen Bereich auszuwählen (von links nach rechts: was vollständig darin liegt; von rechts nach links: alles, was berührt wird). **Umschalt**-Klick fügt hinzu, **{mod}D** dupliziert, die Pfeiltasten verschieben um 2,5 mm (10 mit Umschalt), **Entf** löscht.',
  'tour.edit.tip':
    'Rückgängig speichert die letzten 500 Schritte, experimentieren Sie also ruhig. Speichern Sie trotzdem vor großen Änderungen wie dem Erzeugen von Blättern oder dem Neunummerieren: Die Datei ist Ihr Sicherheitsnetz, nicht die Rückgängig-Liste.',
  'tour.circuits.title': 'Die Stromkreistabelle',
  'tour.circuits.p1':
    '**Stromkreise** öffnet die Tabelle des Verteilers: eine Zeile pro LS, mit Bezeichnung, Nennstrom, Kennlinie, FI, Kabel, Querschnitt, Länge, Verlegeart und Punkten.',
  'tour.circuits.p2':
    'Ändern Sie eine Zelle und der Plan folgt — hier eine Bezeichnung. Tabelle und Blatt sind zwei Ansichten desselben Verteilers.',
  'tour.circuits.tip':
    'Das ist der schnellste und sicherste Weg zu einem Einliniendiagramm. Zeichnen Sie den Kopf des Verteilers ruhig von Hand, dann fügen Sie die Stromkreise hier hinzu und bearbeiten sie, statt jeden einzeln zu zeichnen.',
  'tour.addCircuit.title': 'Einen Stromkreis mit einem Klick hinzufügen',
  'tour.addCircuit.p1':
    'Wählen Sie den FI, unter dem der Stromkreis liegt, und seine Art — Steckdosen, Beleuchtung oder ein Gerät —, dann **Stromkreis hinzufügen**.',
  'tour.addCircuit.p2':
    'Tablo zeichnet den LS, die Punkte und die Sammelschiene, schafft Platz und trägt die üblichen Werte ein: 16 A / 1,5 mm² für Beleuchtung, 20 A / 2,5 mm² für Steckdosen.',
  'tour.addCircuit.tip':
    'Setzen Sie jeden Stromkreis von Anfang an unter den richtigen FI: Badezimmer, Waschmaschine, Geschirrspüler und Trockner gehören unter den 30-mA-FI. Begrenzen Sie Steckdosenstromkreise auf höchstens 8 Punkte — die Tabelle zählt sie für Sie.',
  'tour.calc.title': 'Berechnungen während der Eingabe',
  'tour.calc.p1':
    '**Ib** ist der Betriebsstrom; **Iz** das, was das Kabel je nach Isolierung und Verlegeart führen kann.',
  'tour.calc.p2':
    '**ΔU** ist der Spannungsfall (üblicherweise 3 % für Beleuchtung, 5 % für den Rest). Mit 28 m 1,5 mm² besteht der Beleuchtungsstromkreis nicht: Der Wert wird rot.',
  'tour.calc.p3':
    '**Max. L** ist die größte Kabellänge, die noch gegen Kurzschluss geschützt ist. Jeder rote Wert besteht nicht.',
  'tour.calc.tip':
    'Geben Sie die echten Kabellängen ein, gemessen im Plan oder vor Ort: Spannungsfall und Maximallänge sind nur so gut wie diese Zahlen. Sie sind Planungshilfen — maßgebend bleiben die Messungen der Kontrolle.',
  'tour.renumber.title': 'Die Stromkreise nummerieren',
  'tour.renumber.p1':
    '**Stromkreise nummerieren** bringt die Codes wieder in Reihenfolge — A1, A2, A3… —, nachdem Stromkreise hinzugefügt, verschoben oder entfernt wurden.',
  'tour.renumber.p2':
    'Jeder Punkt trägt den Code seines Stromkreises, gleich im Einliniendiagramm, im Lageplan und auf der Verteilerbeschriftung.',
  'tour.renumber.tip':
    'Nummerieren Sie neu, sobald der Verteiler feststeht und bevor Sie Pläne, Beschriftungen und Übergabeunterlagen erstellen — nicht danach. Codes, die sich ändern, wenn die Dokumente schon auf der Baustelle sind, führen zu Fehlern.',
  'tour.assistant.title': 'Den KI-Assistenten fragen',
  'tour.assistant.p1':
    '**KI → Assistent** öffnet den Bereich **KI-Assistent** der Seitenleiste. Er bleibt beim Zeichnen geöffnet und behält die Unterhaltung.',
  'tour.assistant.p2':
    'Tippen oder diktieren Sie eine Anfrage in eigenen Worten — gern mehrere Änderungen auf einmal —, dann **Senden**.',
  'tour.assistant.p3':
    'Jede Antwort listet die vorgeschlagenen Änderungen auf und was die AREI-Prüfung dazu sagen würde. **Übernehmen** führt sie in einem Zug aus, als ein einziger Rückgängig-Schritt.',
  'tour.assistant.tip':
    'Lesen Sie den Vorschlag, bevor Sie ihn übernehmen, und prüfen Sie das Ergebnis auf dem Blatt: Der Assistent entwirft, Sie unterschreiben. Eine klare Anfrage nach der anderen liefert die besten Ergebnisse.',
  'tour.checks.title': 'Die AREI-Prüfung',
  'tour.checks.p1':
    'Der Bereich **AREI-Prüfung** listet Fehler, Warnungen und Hinweise auf, aktualisiert bei jeder Änderung.',
  'tour.checks.p2':
    'Jeder Eintrag nennt die Regel und sagt, warum und wie sie zu beheben ist; klicken Sie darauf, um das Betroffene auszuwählen. Als **zu bestätigen** markierte Regeln stammen aus Sekundärquellen.',
  'tour.checks.p3': 'Der Zähler in der Statusleiste ist immer sichtbar.',
  'tour.checks.tip':
    'Behalten Sie den Zähler beim Zeichnen im Blick und beheben Sie Probleme, sobald sie auftreten; streben Sie vor dem Export null Fehler an. Die Prüfung ist eine Hilfe — es entscheidet weiterhin die zugelassene Kontrollstelle.',
  'tour.multiline.title': 'Das Mehrliniendiagramm erzeugen',
  'tour.multiline.p1':
    '**Schema → Mehrliniendiagramm erzeugen** baut es aus dem Einliniendiagramm auf einem neuen Blatt auf: Eingangsklemmleiste X0, Hauptschalter, FI, Sammelschienen, LS und Abgangsklemmleiste X1.',
  'tour.multiline.p2': 'Wenn sich das Einliniendiagramm ändert, bietet dieses Banner **Aktualisieren** an.',
  'tour.multiline.p3':
    'Im selben Menü werden Leitungen und Klemmen nummeriert, Katalogreferenzen zugewiesen und die Verteileransicht erstellt.',
  'tour.multiline.tip':
    'Zeichnen Sie nie neu, was Tablo erzeugen kann. Ändern Sie das Einliniendiagramm und klicken Sie auf **Aktualisieren**: Manuelle Änderungen auf einem erzeugten Blatt werden ersetzt.',
  'tour.sheets.title': 'Ein Projekt, viele Blätter',
  'tour.sheets.p1':
    'Das **+** nach den Reitern fügt ein Blatt hinzu: Einliniendiagramm, Mehrliniendiagramm, **Steuerstromlaufplan** (Spulen und Kontakte über ihr Kennzeichen verknüpft) oder **Lageplan** (Grundriss als PDF, Bild oder DXF importieren, Maßstab festlegen, Räume mit **P** zeichnen, Punkte platzieren).',
  'tour.sheets.p2':
    'Klicken Sie auf einen Reiter, um das Blatt zu wechseln; doppelklicken Sie, um es umzubenennen.',
  'tour.sheets.tip':
    'Halten Sie eine Anlage in einem Projekt. Platzieren Sie Punkte im Lageplan aus der Liste **Zu platzieren** statt aus der Palette: Sie behalten den Code ihres Stromkreises, sodass Plan und Schema übereinstimmen, wie es die AREI verlangt.',
  'tour.save.title': 'Speichern und übergeben',
  'tour.save.p1': '**{mod}S** speichert eine **.tablo**-Datei mit allem darin, Pläne und Fotos inbegriffen.',
  'tour.save.p2':
    '**Revisionen** friert das Projekt als A, B… mit einer Beschreibung ein, angezeigt im Schriftfeld; **Vergleichen** zeigt, was sich geändert hat.',
  'tour.save.p3':
    '**Exportieren — PDF + Stromkreisliste** erstellt den vollständigen Übergabesatz; Angebot, Beschriftungen und Berichte finden Sie im selben Menü.',
  'tour.save.p4':
    '**Melden Sie sich an**, um Ihre Geräte zu synchronisieren, im Team zu arbeiten und einen Nur-Lese-Link zu teilen.',
  'tour.save.tip':
    'Die automatische Sicherung rettet Sie nur nach einem Absturz; sie ist kein Speicherort. Speichern Sie die Datei oder stellen Sie das Projekt in die Cloud, und frieren Sie jedes Mal eine Revision ein, wenn ein Plan Ihre Hände verlässt, damit Sie immer sagen können, was sich seitdem geändert hat.',
  'tour.done.title': 'Sie sind bereit',
  'tour.done.body':
    'Sie haben ein Projekt begonnen, einen Verteiler von Hand und mit der Stromkreistabelle gezeichnet, die Berechnungen und die Prüfung gelesen und das Mehrliniendiagramm erzeugt. Die Gewohnheiten, die sich lohnen:\n- mit einer Vorlage oder einer Aufnahme vor Ort beginnen;\n- zuerst die Projektinformationen ausfüllen;\n- Leitungen auf Anschlüssen beenden und echte Werte eingeben;\n- Stromkreise in der Tabelle aufbauen, vor der Übergabe neu nummerieren;\n- erzeugen statt neu zeichnen, und auf Aktualisieren klicken;\n- die Datei speichern und für jede Ausgabe eine Revision einfrieren.',
  'tour.done.tip':
    'Öffnen Sie **Datei → Beispiel**, um ein vollständiges Haus zu sehen, oder **Datei → Neu aus Vorlage** für Ihren ersten echten Auftrag. Nach dem Auftrag nimmt das Menü **Kontrolle** die Messergebnisse, den Kontrollbericht und die Rechnung auf. Dieses Tutorial bleibt unter **Datei → Geführtes Tutorial**.',
  'checks.goBlankingOk': 'Abdeckungen angebracht',
  'checks.goBalance': 'Phasen ausgleichen',
  'checks.balanceNone': 'Die Phasen sind bereits bestmöglich verteilt.',
  'checks.balanced':
    '{n} Stromkreis(e) auf eine andere Phase verlegt. Aktualisieren Sie das Mehrliniendiagramm.',
  'checks.goAddNorth': 'Nordpfeil hinzufügen',
  'checks.goDrawRoutes': 'Kabelwege zeichnen',
  'checks.routesNone': 'Nichts zu zeichnen: Jeder Stromkreis auf dem Plan hat bereits seinen Kabelweg.',
  'checks.routesDrawn':
    '{n} Kabelabschnitt(e) auf dem kürzesten Weg gezeichnet: Verschieben Sie sie auf den tatsächlichen Verlauf.',
  'survey.blanking': 'Abdeckungen',
  'survey.blankingOk': 'Alle angebracht',
  'survey.blankingMissing': 'Fehlen',
  'survey.blankingHint': 'Sind die freien Plätze des Verteilers abgedeckt? (AREI Art. 49)',
  'checks.report': 'Einen Fehler in dieser Regel melden',
  'checks.reportTitle': 'Was stimmt mit {rule} nicht?',
  'checks.reportWrong': 'Die Regel ist falsch',
  'checks.reportNotApplicable': 'Sie gilt hier nicht',
  'checks.reportWording': 'Der Text ist unklar',
  'checks.reportOther': 'Sonstiges',
  'checks.reportComment': 'Was die Norm sagt oder was die Kontrollstelle akzeptiert (optional)',
  'checks.reportPrivacy':
    'An Tablo gesendet: die Regel, der Text des Befunds und Ihr Kommentar, nicht das Projekt.',
  'checks.reportSend': 'Senden',
  'checks.reportThanks': 'Danke: Die Regel wird anhand des Normtexts überprüft.',
  'checks.reportError': 'Senden ist gerade nicht möglich. Versuchen Sie es später erneut.',
  'checks.reportSignIn': 'Zum Melden einer Regel ist ein kostenloses Tablo-Konto nötig.',
  'checks.reportSignInButton': 'Anmelden',
  'signoff.menu': 'Unterschrift des Kunden…',
  'signoff.title': 'Unterschrift des Kunden',
  'signoff.handoverText':
    'Der Kunde bestätigt, die Anlage „{title}“ und ihre Unterlagen (Index {revision}) erhalten zu haben.',
  'signoff.surveyText': 'Der Kunde bestätigt die Aufnahme der Anlage „{title}“ wie notiert.',
  'signoff.name': 'Name des Unterzeichners',
  'signoff.note': 'Bemerkungen oder Vorbehalte (optional)',
  'signoff.padLabel': 'Unterschriftsfeld: mit dem Finger oder einem Stift unterschreiben',
  'signoff.clear': 'Löschen',
  'signoff.save': 'Unterschrift speichern',
  'signoff.saved': 'Unterschrift im Projekt gespeichert.',
  'signoff.txAdd': 'Unterschrift von {name}',
  'signoff.txRemove': 'Eine Unterschrift entfernen',
  'signoff.remove': 'Entfernen',
  'signoff.of': 'Unterschrift von {name}',
  'signoff.kindHandover': 'Übergabe',
  'signoff.kindSurvey': 'Aufnahme',
  'signoff.revision': 'Index {r}',
  'signoff.pack': 'Übergabeunterlagen (PDF)',
  'signoff.step': 'Unterschrift',
  'survey.signoff': 'Vom Kunden unterschreiben lassen',
  'survey.notSigned': 'Der Kunde hat die Aufnahme noch nicht unterschrieben.',
  'survey.signedBy': 'Unterschrieben von {name} am {date}.',
  'meta.ownerEmail': 'E-Mail des Kunden',
  'meta.ownerPhone': 'Telefon des Kunden',
  'meta.usage': 'Art der Anlage',
  'meta.usageHint':
    'Legt den Abstand der periodischen Kontrolle fest (AREI: 25 Jahre Wohnbereich, 5 Jahre Nicht-Wohnbereich).',
  'meta.usageDomestic': 'Wohnbereich (Wohnung)',
  'meta.usageNonDomestic': 'Nicht-Wohnbereich (Gewerbe, Industrie)',
  'clients.menu': 'Kunden und Baustellen…',
  'clients.title': 'Kunden und Baustellen',
  'clients.loading': 'Online-Projekte werden geladen…',
  'clients.cloudError': 'Online-Projekte nicht verfügbar: Nur die dieses Geräts werden angezeigt.',
  'clients.count': '{n} Kunde(n)',
  'clients.ics': 'Erinnerungen in den Kalender (.ics)',
  'clients.icsFile': 'Tablo Kontrollen',
  'clients.icsPeriodic': 'Periodische Kontrolle',
  'clients.icsReinspection': 'Nachkontrolle',
  'clients.remindersTitle': 'Anstehende Kontrollen (6 Monate)',
  'clients.duePeriodic': 'periodische Kontrolle am {date}',
  'clients.dueReinspection': 'Nachkontrolle vor dem {date}',
  'clients.overdue': '({n} Tage überfällig)',
  'clients.inDays': '(in {n} Tagen)',
  'clients.search': 'Kunde, Adresse oder Projekt suchen',
  'clients.noMatch': 'Kein Kunde gefunden.',
  'clients.empty': 'Noch kein Projekt mit Kunde: Füllen Sie Datei → Projektinformationen aus.',
  'clients.noName': '(ohne Namen)',
  'clients.noAddress': '(keine Adresse)',
  'clients.untitled': '(ohne Titel)',
  'clients.lastInspection': 'kontrolliert am {date}: {result}',
  'clients.result.conform': 'konform',
  'clients.result.not-conform': 'nicht konform',
  'clients.result.unknown': 'Ergebnis ?',
  'clients.noInspection': 'keine Kontrolle erfasst',
  'clients.openRemarks': '{n} offene Bemerkung(en)',
  'clients.isOpen': 'jetzt geöffnet',
  'clients.inCloud': 'online',
  'clients.onDevice': 'auf diesem Gerät',
  'clients.onDeviceFile': 'Datei „{file}“',
  'clients.open': 'Öffnen',
  'clients.forget': 'Aus der Liste entfernen',
  'clients.hint':
    'Die Liste enthält die auf diesem Gerät geöffneten Projekte und die Ihrer Online-Arbeitsbereiche. AREI-Fristen: 25 Jahre (Wohnbereich) oder 5 Jahre (Nicht-Wohnbereich) nach einer konformen Kontrolle, 12 Monate zur Behebung nach einer nicht konformen.',
  'menu.labelsTape': 'Etiketten für Etikettendrucker — Band {mm} mm (PDF)',
  'report.tapeHint':
    '{n} Streifen, einer pro Reihe. Mit 100 % auf {mm}-mm-Band drucken (Brother P-touch, Dymo: benutzerdefinierte Länge im Treiber).',
  'instr.button': 'Aus einem Prüfgerät importieren…',
  'instr.title': 'Ergebnisse des Prüfgeräts — {file}',
  'instr.summary': '{n} Zeile(n) mit Messwerten, {m} einem Stromkreis oder FI zugeordnet',
  'instr.unreadable':
    'Datei nicht lesbar: Exportieren Sie als CSV oder Excel (.xlsx) aus der Software des Prüfgeräts.',
  'instr.record': '{n} Ergebnis(se) speichern',
  'instr.tx': 'Import aus Prüfgerät ({n} Zeilen)',
  'instr.done': 'Messwerte importiert — Stromkreise: {c}; FI: {r}.',
  'instr.line': 'Zeile',
  'instr.goesTo': 'Geht an',
  'instr.skip': '(überspringen)',
  'instr.fieldRef': 'Stromkreis / Ort',
  'instr.fieldInsulation': 'Isolation',
  'instr.fieldTestVoltage': 'Prüfspannung',
  'instr.fieldContinuity': 'Durchgang PE',
  'instr.fieldLoop': 'Schleife Zs',
  'instr.fieldTripMs': 'Auslösezeit',
  'instr.fieldTripMa': 'Auslösestrom',
  'instr.fieldDate': 'Datum',
  'instr.hint':
    'Jede Marke benennt ihre Spalten anders: Prüfen Sie die Spalte jedes Werts und den Stromkreis jeder Zeile. Auslösezeiten und -ströme in der Zeile eines Stromkreises gehen an den FI, der ihn schützt. Ein am selben Tag bereits gemessener Stromkreis wird aktualisiert.',
  'pick.menu': 'Materialentnahmeliste…',
  'pick.title': 'Materialentnahmeliste',
  'pick.summary': '{n} Artikel, {o} zu bestellen',
  'pick.take': 'Aus dem Wagen nehmen',
  'pick.taken': 'Bestand im Wagen aktualisiert.',
  'pick.excel': 'Bestellung (Excel)',
  'pick.csv': 'Bestellung für den Großhandel (CSV)',
  'pick.file': 'Entnahmeliste',
  'pick.order': 'Bestellung',
  'pick.ref': 'Referenz',
  'pick.desc': 'Bezeichnung',
  'pick.needed': 'Benötigt',
  'pick.inVan': 'Im Wagen',
  'pick.toOrder': 'Zu bestellen',
  'pick.hint':
    'Der Bestand im Wagen wird auf diesem Gerät gespeichert und gilt für alle Baustellen. Kabel in Metern, mit Verschnitt (10 %). Die CSV „Referenz;Menge“ lässt sich in die Webshops der Großhändler importieren.',
  'share.copyHome': 'Link für die Bewohner kopieren',
  'home.title': 'Ihre Elektroanlage',
  'home.loading': 'Wird geladen…',
  'home.error': 'Dieser Link ist nicht mehr gültig. Bitten Sie Ihren Elektriker um einen neuen.',
  'home.underRcd': 'Unter dem FI {tag} ({ma} mA)',
  'home.noRcd': 'Stromkreise',
  'home.circuit': 'Stromkreis',
  'home.sockets': '{n} Steckdose(n)',
  'home.lights': '{n} Lichtpunkt(e)',
  'home.appliances': '{n} Gerät(e)',
  'home.tripTitle': 'Wenn ein FI auslöst',
  'home.trip1':
    'Ziehen Sie gerade eingesteckte Geräte aus und schalten Sie die LS unter diesem FI aus (siehe Liste oben).',
  'home.trip2': 'Schalten Sie den FI wieder ein (Hebel nach oben).',
  'home.trip3':
    'Schalten Sie die LS einzeln wieder ein. Der, bei dem der FI erneut auslöst, ist der fehlerhafte Stromkreis: Lassen Sie ihn aus.',
  'home.trip4':
    'Ziehen Sie an diesem Stromkreis alles aus und stecken Sie die Geräte einzeln wieder ein, um das fehlerhafte zu finden.',
  'home.trip5':
    'Löst er auch ohne angeschlossene Geräte oder immer wieder aus, rufen Sie Ihren Elektriker an.',
  'home.test':
    'Drücken Sie ab und zu die Taste „T“ jedes FI: Er muss sofort auslösen. Schalten Sie ihn danach wieder ein.',
  'home.never':
    'Erzwingen Sie nie einen FI oder LS, der nicht eingeschaltet bleibt, und öffnen Sie den Verteiler nicht.',
  'home.installer': 'Installateur: {name}',
  'home.drawings': 'Die Pläne der Anlage ansehen',
  'energy.menu': 'Energie: Kapazitätstarif und Netzbetreiber…',
  'energy.title': 'Energie',
  'energy.capacityTitle': 'Kapazitätstarif (Flandern)',
  'energy.notFlanders': 'Der Kapazitätstarif gilt in Flandern; diese Adresse liegt nicht dort.',
  'energy.basePeak': 'Durchschnittliche Monatsspitze heute (kW)',
  'energy.area': 'Fluvius-Gebiet (2026)',
  'energy.noLoads': 'Kein großes Gerät mit angegebener Leistung (Ladepunkt, Wärmepumpe…).',
  'energy.before': 'Heute',
  'energy.after': 'Mit den neuen Geräten',
  'energy.managed': 'Mit Lastmanagement (Ladepunkt auf {kw})',
  'energy.year': 'Jahr',
  'energy.advice':
    'Lastmanagement (der Ladepunkt drosselt auf {kw}, während das Haus verbraucht) spart etwa {eur} pro Jahr Kapazitätstarif.',
  'energy.hint':
    'Eine Schätzung: Die tatsächliche Spitze ist der Durchschnitt der höchsten Viertelstunde jedes Monats (mindestens 2,5 kW), in den Daten des digitalen Zählers. Haken Sie die Geräte an, die zur Spitze des Hauses laufen.',
  'energy.gridTitle': 'Netzbetreiber',
  'energy.operator': 'Netzbetreiber dieser Adresse: {op}.',
  'energy.operatorCheck': 'Wahrscheinlicher Netzbetreiber: {op} (zu prüfen: hängt von der Gemeinde ab).',
  'energy.noPostcode': 'Keine Postleitzahl in der Adresse: Wählen Sie den Netzbetreiber.',
  'energy.nothingToTell': 'Der Plan hat keine PV-Module, keinen Wechselrichter, Ladepunkt oder Wärmepumpe.',
  'energy.operatorLabel': 'Netzbetreiber',
  'energy.inverter': 'Wechselrichter (Marke, Modell)',
  'energy.batteryKwh': 'Batterie (kWh)',
  'energy.batteryKw': 'Batterie (kW)',
  'energy.date': 'Inbetriebnahme',
  'energy.ev': 'Ladepunkt',
  'energy.heatPump': 'Wärmepumpe',
  'energy.pdf': 'Daten für {op} (PDF)',
  'teamleader.connect': 'Teamleader verbinden…',
  'teamleader.send': 'An Teamleader senden',
  'teamleader.sent': 'Angebot an Teamleader gesendet: ein Deal und ein Angebot beim bestehenden Kunden.',
  'teamleader.sentNew': 'Angebot an Teamleader gesendet: Kunde hinzugefügt, mit Deal und Angebot.',
  'teamleader.error': 'Teamleader: {msg}',
  'teamleader.connected': 'Teamleader ist verbunden: Senden Sie Ihre Angebote aus dem Angebot.',
  'teamleader.failed': 'Die Verbindung mit Teamleader ist fehlgeschlagen. Versuchen Sie es erneut.',
  'teamleader.material': 'Material',
  'teamleader.cables': 'Kabel',
  'teamleader.labour': 'Arbeit',
  'remedy.button': 'Angebot Mängelbehebung…',
  'remedy.title': 'Angebot zur Mängelbehebung',
  'remedy.intro':
    'Jede offene Bemerkung des Berichts wird zu Angebotszeilen: die übliche Behebung, ihr Material und ihre Stunden. Passen Sie Arbeit, Menge und Stunden an, dann exportieren oder abrechnen.',
  'remedy.remark': 'Bemerkung',
  'remedy.fix': 'Arbeit',
  'remedy.qty': 'Menge',
  'remedy.hours': 'Stunden',
  'remedy.include': 'Bemerkung {n} aufnehmen',
  'remedy.none': 'Keine offene Bemerkung in diesem Bericht: nichts anzubieten.',
  'remedy.unpriced':
    '{n} Zeile(n) ohne Preis (Blindabdeckungen, Erder…): in der Excel-Datei oder Ihrer Preisliste ergänzen.',
  'remedy.file': 'Angebot Mängelbehebung',
  'scan.title': 'Raumscan',
  'scan.summary':
    '{walls} Wände, {doors} Türen, {windows} Fenster, {rooms} Raum/Räume erkannt — {w} × {h} m.',
  'scan.story': 'Geschoss',
  'scan.storyN': 'Ebene {n}',
  'scan.objects': 'Erkannte Möbel und Geräte zeichnen ({n})',
  'scan.note':
    'Der Plan ist maßstabsgetreu. Wände werden auf ihrer Mittellinie gezeichnet, da der Scan ihre Dicke nicht misst: Prüfen Sie wichtige Maße vor Ort.',
  'scan.start': 'Räume scannen (LiDAR)…',
  'scan.failed': 'Scan fehlgeschlagen: {msg}',
  'scan.notScan': 'Diese JSON-Datei ist kein Raumscan (RoomPlan).',
  'offer.send': 'Zur Online-Annahme senden…',
  'offer.title': 'Online-Annahme',
  'offer.intro':
    'Der Kunde erhält einen Link: Er liest das Angebot, unterschreibt mit dem Finger oder der Maus, nimmt es an und sieht dann, wie er die Anzahlung bezahlt. Sie werden per E-Mail benachrichtigt.',
  'offer.docTitle': 'Titel des Angebots',
  'offer.number': 'Nummer',
  'offer.valid': 'Gültig (Tage)',
  'offer.deposit': 'Anzahlung bei Annahme (%)',
  'offer.note': 'Bedingungen und Nachricht an den Kunden',
  'offer.noIban':
    'Ohne IBAN in Ihren Rechnungsdaten (Kontrolle → Rechnungen) sieht der Kunde keinen QR-Code zum Bezahlen der Anzahlung.',
  'offer.unpriced': '{n} Zeile(n) ohne Preis: Ergänzen Sie die Preise, bevor Sie das Angebot senden.',
  'offer.create': 'Link erstellen',
  'offer.link': 'Link für den Kunden',
  'offer.copy': 'Link kopieren',
  'offer.copied': 'Link kopiert.',
  'offer.email': 'Per E-Mail senden…',
  'offer.mailSubject': 'Angebot: {title}',
  'offer.mailBody':
    'Guten Tag,\n\nanbei unser Angebot „{title}“. Sie können es online lesen und annehmen:\n{url}\n\nMit freundlichen Grüßen\n{seller}',
  'offer.sent': 'Zur Annahme gesendet',
  'offer.none': 'Noch kein Angebot online für dieses Projekt gesendet.',
  'offer.statusOpen': 'Offen, gültig bis {date}',
  'offer.statusAccepted': 'Angenommen von {name} am {date}',
  'offer.statusWithdrawn': 'Zurückgezogen',
  'offer.statusExpired': 'Abgelaufen am {date}',
  'offer.withdraw': 'Zurückziehen',
  'offer.signIn': 'Melden Sie sich an, um ein Angebot zur Online-Annahme zu senden.',
  'offer.failed': 'Senden fehlgeschlagen: {msg}',
  'offer.signature': 'Unterschrift von {name}',
  'offerPage.loading': 'Angebot wird geladen…',
  'offerPage.error': 'Dieser Link funktioniert nicht mehr. Wenden Sie sich an Ihren Installateur.',
  'offerPage.from': 'Angebot von {seller}',
  'offerPage.for': 'Für',
  'offerPage.site': 'Baustelle',
  'offerPage.dates': 'Vom {date} · gültig bis {until}',
  'offerPage.colDesc': 'Bezeichnung',
  'offerPage.colQty': 'Menge',
  'offerPage.colPrice': 'EP exkl. MwSt.',
  'offerPage.colTotal': 'Summe exkl. MwSt.',
  'offerPage.discount': '{pct} % Rabatt auf Material und Kabel.',
  'offerPage.vat': 'MwSt. {pct} %',
  'offerPage.subtotal': 'Summe exkl. MwSt.',
  'offerPage.total': 'Summe inkl. MwSt.',
  'offerPage.acceptTitle': 'Das Angebot annehmen',
  'offerPage.depositAsk': 'Bei Annahme wird eine Anzahlung von {pct} % ({amount}) verlangt.',
  'offerPage.name': 'Ihr Name',
  'offerPage.sign': 'Ihre Unterschrift',
  'offerPage.agree': 'Ich habe dieses Angebot gelesen und nehme es mit seinen Bedingungen an.',
  'offerPage.accept': 'Annehmen und unterschreiben',
  'offerPage.sending': 'Wird gesendet…',
  'offerPage.thanks': 'Danke, das Angebot ist angenommen. {seller} wurde benachrichtigt.',
  'offerPage.accepted': 'Angebot angenommen von {name} am {date}.',
  'offerPage.pay': 'Die Anzahlung bezahlen: {amount}',
  'offerPage.payHow':
    'Scannen Sie den Code mit Ihrer Banking-App oder überweisen Sie {amount} auf {iban} ({name}) mit der Mitteilung {ref}.',
  'offerPage.expired': 'Dieses Angebot ist am {date} abgelaufen. Bitten Sie Ihren Installateur um ein neues.',
  'offerPage.failed': 'Die Annahme ist fehlgeschlagen: {msg}',
  'offerPage.contact': 'Eine Frage? Wenden Sie sich an {seller}',
  'offerPage.privacy':
    'Ihr Name und Ihre Unterschrift werden mit dem Angebot für den Installateur gespeichert.',
  'rev.between': 'Zwei Stände vergleichen',
  'rev.from': 'Von',
  'rev.to': 'Bis',
  'rev.now': 'Jetzt',
  'rev.show': 'Auf den Plänen zeigen',
  'rev.pdf': 'PDF der Änderungen',
  'rev.diffBetween':
    'Revision {from} → {to}: {added} hinzugefügt, {changed} geändert, {removed} entfernt — grün, orange und rot gestrichelt. Nur lesen.',
  'rev.list': 'Liste der Änderungen',
  'rev.listTitle': 'Änderungen von {from} bis {to}',
  'rev.noChange': 'Keine Änderung an den Plänen.',
  'rev.kindAdded': 'Hinzugefügt',
  'rev.kindChanged': 'Geändert',
  'rev.kindRemoved': 'Entfernt',
  'rev.wires': 'Leitungen: {added} hinzugefügt, {removed} entfernt, {changed} geändert',
  'rev.file': 'Änderungen',
  'inspection.since': 'Was sich seit dieser Prüfung geändert hat (Revision {index})',
  'inspection.noRevision':
    'Erstellen Sie vor der Prüfung eine Revision (Datei → Revisionen), um später zu sehen, was sich seitdem geändert hat.',
  'share.createReview': 'Link für die Prüfstelle',
  'share.reviewHint':
    'Der Prüfer sieht die Pläne schreibgeschützt und heftet seine Bemerkungen direkt darauf; Sie übernehmen sie unter Kontrolle → Prüfberichte.',
  'share.review': 'Prüfstelle',
  'review.banner': 'Online-Prüfung: {n} Bemerkung(en) angeheftet.',
  'review.pin': 'Bemerkung anheften',
  'review.picking': 'Klicken Sie auf die Stelle im Plan, die die Bemerkung betrifft (Esc zum Abbrechen)',
  'review.list': 'Bemerkungen',
  'review.title': 'Bemerkung Nr. {n}',
  'review.author': 'Prüfer',
  'review.body': 'Prüfstelle',
  'review.text': 'Bemerkung',
  'review.article': 'Artikel',
  'review.ref': 'Stromkreis oder Punkt',
  'review.save': 'Anheften',
  'review.delete': 'Entfernen',
  'review.taken': 'vom Installateur übernommen',
  'review.none': 'Keine Bemerkung angeheftet.',
  'review.failed': 'Bemerkung nicht gespeichert: {msg}',
  'review.sheet': 'Blatt {name}',
  'inspection.pins': '{n} Bemerkung(en) online von der Prüfstelle angeheftet',
  'inspection.importPins': 'Als Prüfbericht übernehmen',
  'inspection.pinsReference': 'Online-Prüfung',
  'inspection.txPins': 'Online-Bemerkungen übernehmen',
  'inspection.showPin': 'Im Plan zeigen',
  'cat.generation': 'PV-Erzeugung und Batterie',
  'pv.menu': 'Photovoltaikanlage…',
  'pv.title': 'Photovoltaikanlage',
  'pv.intro':
    'Fügt dem Verteiler einen eigenen Stromkreis für den Wechselrichter unter einem eigenen FI hinzu und zeichnet die DC-Seite auf einem neuen Blatt: Stränge, DC-Trennschalter, Überspannungsschutz, Wechselrichter und Batterie.',
  'pv.board': 'Verteiler',
  'pv.strings': 'Modulstränge',
  'pv.string': 'Strang {n}',
  'pv.modules': 'Module',
  'pv.moduleWp': 'Wp je Modul',
  'pv.vocV': 'Voc Strang (V)',
  'pv.addString': '+ Strang',
  'pv.removeString': 'Strang {n} entfernen',
  'pv.inverterKw': 'AC-Leistung des Wechselrichters (kW)',
  'pv.phases': 'Anschluss',
  'pv.mono': 'Einphasig',
  'pv.tri': 'Dreiphasig',
  'pv.battery': 'Batterie (kWh, 0 = keine)',
  'pv.rcdType': 'FI des Wechselrichters',
  'pv.typeB': 'Typ B',
  'pv.typeA': 'Typ A (wenn die Anleitung des Wechselrichters es erlaubt)',
  'pv.sensitivity': 'Empfindlichkeit',
  'pv.dcSpd': 'Überspannungsschutz auf der DC-Seite',
  'pv.summary': '{kwp} kWp · Wechselrichter {kw} kW: LS {rating} A, Kabel {section} mm²',
  'pv.create': 'Anlage zeichnen',
  'pv.noBoard': 'Zeichnen Sie zuerst den Verteiler (Einliniendiagramm mit dem Netzanschluss).',
  'pv.sheetName': 'PV-Anlage — DC-Seite',
  'pv.circuitLabel': 'PV-Wechselrichter',
  'pv.tx': 'Photovoltaikanlage',
  'pv.labelsMenu': 'Schilder der PV-Anlage (PDF)',
  'pv.labelsFile': 'PV-Schilder',
  'pv.noLabels': 'Keine PV-Anlage im Projekt.',
  'sheet.tabs': 'Blätter des Projekts',
  'sheet.menu': 'Blatt „{name}“: Optionen',
  'settings.menu': 'Einstellungen…',
  'settings.title': 'Einstellungen',
  'settings.usage': 'Anonyme Nutzungsstatistiken teilen',
  'settings.usageHint':
    'Wie oft jeder Befehl pro Tag verwendet wird, mit Version und Sprache der App. Kein Konto, keine Adresse, keine Projektinhalte. So wissen wir, was wir verbessern sollen. Standardmäßig aus.',
  'settings.privacy': 'Datenschutzerklärung',
  'backup.title': 'Automatische Sicherung',
  'backup.enable': 'Das geöffnete Projekt automatisch sichern',
  'backup.hint':
    'Eine .tablo-Kopie wird in den gewählten Ordner geschrieben, wenn sich das Projekt geändert hat. Die Kopien bleiben auf diesem Gerät.',
  'backup.folder': 'Ordner',
  'backup.noFolder': 'keiner',
  'backup.choose': 'Wählen…',
  'backup.needsPermission': 'Der Browser fragt nach, bevor er wieder in diesen Ordner schreibt.',
  'backup.resume': 'Erlauben',
  'backup.every': 'Alle',
  'backup.keep': 'Behaltene Kopien je Projekt',
  'backup.now': 'Jetzt sichern',
  'backup.last': 'Letzte Kopie um {time}: {name}',
};
